<template>
  <div>
    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">{{ $t("Reports") }}</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hideSideBar()"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row class="mt-1">
          <template v-if="attObj && attObj.valueBool">
            <b-col
              md="12"
              v-if="!['myskooliota', 'myskooliota2'].includes(reportDomain)"
            >
              <b-form-group :label="$t('Report Type')" class="mb-2">
                <v-select
                  v-model="reportType"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="filteredOptions"
                  :reduce="(val) => val.value"
                  label="text"
                  :clearable="false"
                  :placeholder="$t('Select type')"
                />
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group
                :label="$t('Department')"
                :invalid-feedback="$t('Department is required')"
                ref="dep_multi"
              >
                <v-select
                  multiple
                  :closeOnSelect="false"
                  v-model="dIDs"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="departments"
                  :reduce="(val) => val.id"
                  label="name"
                  :clearable="false"
                  :placeholder="$t('Select department')"
                  @input="setDept()"
                />
              </b-form-group>
            </b-col>
            <b-col md="12" v-if="reportDomain == 'myskoolksa'">
              <b-form-group
                :label="$t('Availability')"
                :invalid-feedback="$t('Availability is required.')"
              >
                <v-select
                  v-model="availability"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="availabilityOptions"
                  :clearable="false"
                  ref="avail"
                  :placeholder="$t('Select availability')"
                />
              </b-form-group>
            </b-col>
          </template>
          <b-col md="12" v-else>
            <b-form-group
              :label="$t('Department')"
              :invalid-feedback="$t('Department is required')"
              ref="rep_dep"
            >
              <v-select
                v-model="repObj.depIDs"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="departments"
                :reduce="(val) => val.id"
                label="name"
                :clearable="false"
                :placeholder="$t('Select department')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12" v-if="!singleVisible.includes(reportType)">
            <b-form-group
              :label="$t('Date')"
              :invalid-feedback="$t('Date is required')"
              ref="rep_date"
            >
              <flat-pickr
                :config="config2"
                v-model="repDate"
                class="form-control"
                :placeholder="$t('Select Date')"
                @on-change="setRepDate"
              />
            </b-form-group>
          </b-col>
          <b-col md="12" v-else>
            <b-form-group
              :label="$t('Date')"
              :invalid-feedback="$t('Date is required')"
              ref="rep_single_date"
            >
              <flat-pickr
                :config="config"
                v-model="repSingleDate"
                class="form-control"
                :placeholder="$t('Select Date')"
              />
            </b-form-group>
          </b-col>

          <!--  <b-col md="12" class="mt-1">
             <b-form-group
              label="Status"
              invalid-feedback="status is required."
              ref="rep_status"
            >
              <v-select
                multiple
                :closeOnSelect="false"
                ref="rep_status"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :clearable="false"
                v-model="repObj.status"
                :options="statusOptions"
                :reduce="(opt) => opt.value"
                label="name"
                placeholder="select status"
                @input="setStatus()"
              />
            </b-form-group>
          </b-col> -->
          <b-col class="mt-1" md="12">
            <b-button
              variant="success"
              @click="getReport()"
              :disabled="request"
              block
            >
              <b-spinner v-if="request" small type="grow" />
              <span v-else>{{ $t("Show") }}</span>
            </b-button>
          </b-col>
          <b-col class="mt-1" md="12">
            <b-button
              variant="warning"
              @click="exportReport()"
              :disabled="exporting"
              block
            >
              <b-spinner v-if="exporting" small type="grow" />
              <span v-else>{{ $t("Export") }}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
      <sidebar-content />
    </b-sidebar>

    <b-modal
      id="modal-sunday"
      cancel-variant="outline-secondary"
      hide-footer
      centered
      no-close-on-backdrop
      :title="$t('Mark Sunday Off')"
      v-model="visibilitySunday"
    >
      <b-form @submit.prevent>
        <b-form-group
          :label="$t('Date')"
          invalid-feedback="Date is required"
          ref="sunday_date"
        >
          <flat-pickr
            :config="config"
            v-model="sundayObj.date"
            class="form-control"
            :placeholder="$t('Select Date')"
          />
        </b-form-group>
        <b-button
          variant="success"
          block
          class="mt-1"
          :disabled="markingSunday"
          @click="markSundayOff()"
        >
          <b-spinner v-if="markingSunday" small type="grow" />
          <span v-else>{{ $t("Save") }}</span>
        </b-button>
      </b-form>
    </b-modal>

    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility4"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">{{ $t("Mark Holiday") }}</h5>
        <div class="d-flex align-items-center">
          <b-button
            variant="outline-primary"
            class="btn-icon mr-50"
            size="sm"
            v-b-tooltip.hover.top
            :title="$t('Status History')"
            @click="openHolidayHistory()"
          >
            <feather-icon icon="ClockIcon" size="16" />
          </b-button>
          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="visibility4 = false"
          />
        </div>
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row class="mt-1">
          <b-col md="12" v-if="shouldShowHolidayCampusDropdown">
            <b-form-group
              :label="$t('Campus')"
              :invalid-feedback="$t('Campus is required')"
              ref="hol_campus"
            >
              <v-select
                multiple
                :closeOnSelect="false"
                v-model="holiObj.campusIDs"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="holidayCampusOptions"
                :reduce="(val) => val.id"
                label="branch"
                :clearable="false"
                @input="setHoliCampus()"
                ref="hol_campus"
                :placeholder="$t('Select campus')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              :label="$t('Department')"
              :invalid-feedback="$t('Department is required')"
              ref="hol_dep"
            >
              <v-select
                multiple
                :closeOnSelect="false"
                v-model="holiObj.departmentIDs"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="holidayDepartments"
                :reduce="(val) => val.id"
                label="name"
                :clearable="false"
                @input="setHoliDept()"
                ref="hol_dep"
                :placeholder="$t('Select department')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              :label="$t('Date From')"
              :invalid-feedback="$t('Date is required')"
              ref="hol_dateF"
            >
              <flat-pickr
                ref="hol_dateF"
                :config="config"
                v-model="holiObj.dtFrom"
                class="form-control"
                :placeholder="$t('Select Date')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              :label="$t('Date Till')"
              :invalid-feedback="$t('Date is required')"
              ref="hol_dateT"
            >
              <flat-pickr
                ref="hol_dateT"
                :config="config"
                v-model="holiObj.dtTo"
                class="form-control"
                :placeholder="$t('Select Date')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              :label="$t('Reason')"
              :invalid-feedback="$t('Reason is required')"
              ref="hol_reason"
            >
              <b-form-input
                v-model.trim="holiObj.reason"
                :placeholder="$t('Enter reason')"
              />
            </b-form-group>
          </b-col>

          <b-col class="mt-1" md="12">
            <b-button
              variant="success"
              @click="markHoliday()"
              :disabled="marking"
              block
            >
              <b-spinner v-if="marking" small type="grow" />
              <span v-else>{{ $t("Save") }}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
      <sidebar-content />
    </b-sidebar>

    <!-- Holiday History Modal -->
    <b-modal
      v-model="holidayHistoryVisible"
      hide-header
      hide-footer
      size="xl"
      centered
      no-close-on-backdrop
      body-class="p-0"
      content-class="holiday-history-modal"
    >
      <div class="hh-modal">
        <div class="hh-header">
          <div class="hh-header-left">
            <div class="hh-header-icon">
              <feather-icon icon="ClockIcon" size="18" />
            </div>
            <div>
              <div class="hh-header-title">{{ $t("Status History") }}</div>
              <div class="hh-header-sub">
                {{
                  $t(
                    "View and remove holidays, exam leave, study leave, and off marks"
                  )
                }}
              </div>
            </div>
          </div>
          <button
            type="button"
            class="hh-close-btn"
            @click="holidayHistoryVisible = false"
          >
            <feather-icon icon="XIcon" size="16" />
          </button>
        </div>

        <div class="hh-filters">
          <div class="hh-filter-field">
            <label>{{ $t("Date From") }}</label>
            <flat-pickr
              v-model="holidayHistoryFilters.dtFrom"
              :config="config"
              class="form-control hh-date-input"
              :placeholder="$t('Select Date')"
            />
          </div>
          <div class="hh-filter-field">
            <label>{{ $t("Date Till") }}</label>
            <flat-pickr
              v-model="holidayHistoryFilters.dtTo"
              :config="config"
              class="form-control hh-date-input"
              :placeholder="$t('Select Date')"
            />
          </div>
          <div class="hh-filter-field">
            <label>{{ $t("Status") }}</label>
            <v-select
              v-model="holidayHistoryFilters.status"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="holidayHistoryStatusFilterOptions"
              :reduce="(val) => val.value"
              label="label"
              :clearable="false"
              :placeholder="$t('All types')"
            />
          </div>
          <div class="hh-filter-actions">
            <b-button
              variant="primary"
              class="hh-btn-search"
              :disabled="holidayHistoryLoading"
              @click="loadHolidayHistory(1)"
            >
              <b-spinner v-if="holidayHistoryLoading" small type="grow" />
              <template v-else>
                <feather-icon icon="SearchIcon" size="14" class="mr-50" />
                {{ $t("Search") }}
              </template>
            </b-button>
            <b-button
              variant="flat-secondary"
              class="hh-btn-clear"
              :disabled="holidayHistoryLoading"
              @click="resetHolidayHistoryFilters()"
            >
              {{ $t("Clear") }}
            </b-button>
          </div>
        </div>

        <div class="hh-table-wrap">
          <b-table
            :items="holidayHistoryItems"
            :fields="visibleHolidayHistoryFields"
            :busy="holidayHistoryLoading"
            show-empty
            responsive
            hover
            borderless
            class="holiday-history-table"
          >
            <template #table-busy>
              <div class="hh-busy">
                <b-spinner variant="primary" />
              </div>
            </template>
            <template #empty>
              <div class="hh-empty">
                <feather-icon icon="CalendarIcon" size="28" class="mb-50" />
                <div>{{ $t("No records found") }}</div>
              </div>
            </template>
            <template #cell(campusName)="data">
              <span class="hh-campus">
                {{ formatHolidayHistoryCampus(data.item) }}
              </span>
            </template>
            <template #cell(dtFrom)="data">
              <span class="hh-date-chip">{{
                formatHolidayDate(data.item.dtFrom)
              }}</span>
            </template>
            <template #cell(dtTo)="data">
              <span class="hh-date-chip">{{
                formatHolidayDate(data.item.dtTo)
              }}</span>
            </template>
            <template #cell(status)="data">
              <b-badge
                pill
                :variant="
                  holidayHistoryStatusVariant(
                    resolveHolidayHistoryRowStatus(data.item)
                  )
                "
                class="hh-status-badge"
              >
                {{
                  holidayHistoryStatusLabel(
                    resolveHolidayHistoryRowStatus(data.item)
                  )
                }}
              </b-badge>
            </template>
            <template #cell(reason)="data">
              <span class="hh-reason">{{ data.item.reason || "—" }}</span>
            </template>
            <template #cell(departmentIDs)="data">
              <span class="hh-dept-pill">{{
                formatHolidayDepartments(data.item.departmentIDs)
              }}</span>
            </template>
            <template #cell(createdByName)="data">
              {{
                data.item.createdByName ||
                data.item.createdBy ||
                data.item.userName ||
                "—"
              }}
            </template>
            <template #cell(createdAt)="data">
              <span class="hh-muted">{{
                formatHolidayDateTime(data.item.createdAt)
              }}</span>
            </template>
            <template #cell(actions)="data">
              <div class="hh-actions">
                <button
                  type="button"
                  class="hh-del-btn"
                  :disabled="
                    holidayHistoryDeletingId === holidayHistoryRowId(data.item)
                  "
                  v-b-tooltip.hover.top
                  :title="$t('Delete')"
                  @click="deleteHolidayHistory(data.item)"
                >
                  <b-spinner
                    v-if="
                      holidayHistoryDeletingId ===
                      holidayHistoryRowId(data.item)
                    "
                    small
                    type="grow"
                  />
                  <feather-icon v-else icon="Trash2Icon" size="15" />
                </button>
              </div>
            </template>
          </b-table>
        </div>

        <div v-if="holidayHistoryTotal > 0" class="hh-footer">
          <span class="hh-footer-count">
            {{ $t("Showing") }}
            <strong>{{ holidayHistoryRange.start }}</strong>
            –
            <strong>{{ holidayHistoryRange.end }}</strong>
            {{ $t("of") }}
            <strong>{{ holidayHistoryTotal }}</strong>
          </span>
          <b-pagination
            v-if="holidayHistoryTotal > holidayHistoryPageSize"
            v-model="holidayHistoryPage"
            :total-rows="holidayHistoryTotal"
            :per-page="holidayHistoryPageSize"
            size="sm"
            class="mb-0 hh-pagination"
            @input="loadHolidayHistory"
          />
        </div>
      </div>
    </b-modal>

    <!-- Holiday Summary Modal -->
    <b-modal
      v-model="holidaySummaryVisible"
      hide-header
      hide-footer
      centered
      size="lg"
      body-class="p-0"
    >
      <div v-if="holidaySummary" class="hs-modal">
        <!-- Header -->
        <div class="hs-header">
          <div class="hs-header-left">
            <div
              class="hs-header-icon"
              :class="{ 'hs-header-icon--warn': holidaySummaryHasSkips }"
            >
              <feather-icon
                :icon="
                  holidaySummaryHasSkips
                    ? 'AlertTriangleIcon'
                    : 'CheckCircleIcon'
                "
                size="20"
              />
            </div>
            <div>
              <div class="hs-header-title">{{ $t("Status Summary") }}</div>
              <div class="hs-header-meta">
                <span class="hs-meta-badge">
                  <feather-icon icon="CalendarIcon" size="11" />
                  {{ holidaySummary.dtFrom }} → {{ holidaySummary.dtTo }}
                </span>
                <span
                  class="hs-meta-badge hs-meta-badge--reason"
                  v-if="holidaySummary.reason"
                >
                  <feather-icon icon="TagIcon" size="11" />
                  {{ holidaySummary.reason }}
                </span>
              </div>
            </div>
          </div>
          <button class="hs-close-btn" @click="holidaySummaryVisible = false">
            <feather-icon icon="XIcon" size="16" />
          </button>
        </div>

        <!-- Message -->
        <div
          v-if="holidaySummary.message"
          class="hs-message"
          :class="{ 'hs-message--warn': holidaySummaryHasSkips }"
        >
          <feather-icon
            :icon="holidaySummaryHasSkips ? 'AlertCircleIcon' : 'InfoIcon'"
            size="14"
          />
          <span>{{ holidaySummary.message }}</span>
        </div>

        <!-- Stats row -->
        <div class="hs-stats">
          <div class="hs-stat hs-stat--green">
            <div class="hs-stat-num">{{ holidaySummary.created || 0 }}</div>
            <div class="hs-stat-lbl">Created</div>
          </div>
          <div class="hs-stat hs-stat--blue">
            <div class="hs-stat-num">{{ holidaySummary.updated || 0 }}</div>
            <div class="hs-stat-lbl">Updated</div>
          </div>
          <div class="hs-stat hs-stat--orange">
            <div class="hs-stat-num">
              {{ holidaySummary.alreadyHoliday || 0 }}
            </div>
            <div class="hs-stat-lbl">Already</div>
          </div>
          <div class="hs-stat hs-stat--red" v-if="holidaySummaryHasSkips">
            <div class="hs-stat-num">{{ holidaySummarySkippedCount }}</div>
            <div class="hs-stat-lbl">Skipped</div>
          </div>
          <div class="hs-stat hs-stat--purple" v-else>
            <div class="hs-stat-num">{{ holidaySummaryTotalProcessed }}</div>
            <div class="hs-stat-lbl">Total Processed</div>
          </div>
        </div>

        <!-- Campus breakdown -->
        <div v-if="holidaySummaryCampusRows.length" class="hs-body">
          <div class="hs-section-label">Campus Breakdown</div>
          <div class="hs-campus-table">
            <div class="hs-campus-thead">
              <span>Campus</span>
              <span>Staff</span>
              <span>Created</span>
              <span>Updated</span>
              <span>Total Marked</span>
            </div>
            <div
              v-for="c in holidaySummaryCampusRows"
              :key="c.campusID"
              class="hs-campus-row"
            >
              <div class="hs-campus-info">
                <span class="hs-campus-branch">{{ c.branch }}</span>
                <span class="hs-campus-org">{{ c.campusName }}</span>
              </div>
              <span class="hs-td">{{ c.staffCount }}</span>
              <span class="hs-td hs-td--green">{{ c.created }}</span>
              <span class="hs-td hs-td--blue">{{ c.updated }}</span>
              <span class="hs-td hs-td--purple">{{ c.totalMarked }}</span>
            </div>
          </div>
        </div>

        <!-- Skipped departments -->
        <div
          v-if="holidaySummarySkippedDepartments.length"
          class="hs-body"
          :class="{ 'hs-body--top': !holidaySummaryCampusRows.length }"
        >
          <div class="hs-section-label">
            Skipped Departments
            <span class="hs-section-count">{{
              holidaySummarySkippedDepartments.length
            }}</span>
          </div>
          <div class="hs-skip-table">
            <div class="hs-skip-thead">
              <span>Campus</span>
              <span>Department</span>
              <span>Reason</span>
            </div>
            <div
              v-for="(s, idx) in holidaySummarySkippedDepartments"
              :key="idx"
              class="hs-skip-row"
            >
              <div class="hs-campus-info">
                <span class="hs-campus-branch">{{ s.branch }}</span>
                <span class="hs-campus-org">{{ s.campusName }}</span>
              </div>
              <span class="hs-skip-dept">{{ s.departmentName }}</span>
              <span class="hs-skip-reason">{{ s.reason }}</span>
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="hs-footer">
          <b-button
            variant="primary"
            @click="holidaySummaryVisible = false"
            class="hs-done-btn"
          >
            Done
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility2"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">{{ $t("Send Message") }}</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="visibility2 = false"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row class="pt-1 pb-1" style="align-items: center">
          <b-col md="12">
            <b-form-group
              :label="$t('Department')"
              :invalid-feedback="$t('Department is required')"
              ref="msg_dep"
            >
              <v-select
                multiple
                :closeOnSelect="false"
                v-model="msgIDs"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="departments"
                :reduce="(val) => val.id"
                label="name"
                :clearable="false"
                @input="setMsgDept()"
                ref="msg_dep"
                :placeholder="$t('Select department')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              :label="$t('Date')"
              :invalid-feedback="$t('Date is required')"
              ref="msg_date"
            >
              <flat-pickr
                ref="msg_date"
                :config="config"
                v-model="msgObj.dt"
                class="form-control"
                :placeholder="$t('Select Date')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12" class="mt-1">
            <b-form-group
              :label="$t('Select Status')"
              :invalid-feedback="$t('status is required')"
              ref="msg_status"
            >
              <v-select
                ref="msg_status"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :clearable="false"
                v-model="msgObj.status"
                :options="statusOptions"
                :reduce="(opt) => opt.value"
                label="name"
                :placeholder="$t('select status')"
              />
            </b-form-group>
          </b-col>
          <b-col class="mt-1" md="12">
            <b-button
              variant="success"
              @click="saveMessage()"
              :disabled="request"
              block
            >
              <b-spinner v-if="request" small type="grow" />
              <span v-else>{{ $t("Send Message") }}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
      <sidebar-content />
    </b-sidebar>

    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility3"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">{{ $t("Settings") }}</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="visibility3 = false"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row class="pt-1 pb-1">
          <b-col
            class="d-flex align-items-center justify-content-between mb-1"
            md="12"
          >
            <h4 class="mr-1">{{ $t("Biometric") }}</h4>
            <b-form-checkbox
              v-model="attSettings.attendanceMode"
              value="biometric"
              unchecked-value=""
              switch
            />
          </b-col>
          <b-col
            class="d-flex align-items-center justify-content-between mb-1"
            md="12"
          >
            <h4 class="mr-1">{{ $t("Notify Teacher") }}</h4>
            <b-form-checkbox v-model="notiTeacher.valueBool" switch />
          </b-col>

          <b-col
            class="d-flex align-items-center justify-content-between mb-1"
            md="12"
          >
            <h4 class="mr-1">{{ $t("Notify Manager") }}</h4>
            <b-form-checkbox v-model="notiManager.valueBool" switch />
          </b-col>
          <b-col v-if="notiManager.valueBool" md="12">
            <b-form-group
              :label="$t('Manager Contact')"
              :invalid-feedback="$t('Please enter correct phone number')"
            >
              <vue-tel-input
                :inputOptions="vueTelOptions"
                :dropdownOptions="dropOptions"
                :defaultCountry="$store.state.countryCode"
                @input="CheckContact"
                v-model="notiManager.value"
              ></vue-tel-input>
              <small class="mr-1 text-danger" v-if="phoneerror">{{
                $t("Phone number is required")
              }}</small>
            </b-form-group>
          </b-col>

          <b-col
            class="d-flex align-items-center justify-content-between mb-1"
            md="12"
          >
            <h4 class="mr-1">{{ $t("Double Absent") }}</h4>
            <b-form-checkbox v-model="doubleObj.valueBool" switch />
          </b-col>

          <b-col class="mt-1" md="12">
            <b-button
              variant="success"
              @click="saveSettings()"
              :disabled="savingSettings || (!rights.add && !rights.edit)"
              block
            >
              <b-spinner v-if="savingSettings" small type="grow" />
              <span v-else>{{ $t("Save") }}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
      <sidebar-content />
    </b-sidebar>

    <b-modal
      id="modal-att"
      cancel-variant="outline-secondary"
      hide-footer
      centered
      no-close-on-backdrop
      :title="attendanceModalTitle"
    >
      <b-row class="mb-3">
        <b-col>
          <h6 class="mb-2">{{ $t("Status") }}</h6>
          <div class="status-buttons-container">
            <b-button
              pill
              size="sm"
              class="status-btn"
              :variant="
                currentObj.status == 'P' ? 'success' : 'outline-success'
              "
              @click="currentObj.status = 'P'"
            >
              P
            </b-button>
            <b-button
              pill
              size="sm"
              class="status-btn"
              :variant="currentObj.status == 'A' ? 'danger' : 'outline-danger'"
              @click="currentObj.status = 'A'"
            >
              A
            </b-button>
            <b-button
              v-if="doubleObj && doubleObj.valueBool == true"
              pill
              size="sm"
              class="status-btn"
              :variant="currentObj.status == 'AA' ? 'danger' : 'outline-danger'"
              @click="currentObj.status = 'AA'"
            >
              AA
            </b-button>
            <b-button
              pill
              size="sm"
              class="status-btn"
              :variant="currentObj.status == 'L' ? 'info' : 'outline-info'"
              @click="currentObj.status = 'L'"
            >
              L
            </b-button>
            <b-button
              pill
              size="sm"
              class="status-btn"
              :variant="currentObj.status == 'SL' ? 'info' : 'outline-info'"
              @click="currentObj.status = 'SL'"
            >
              SL
            </b-button>
            <b-button
              pill
              size="sm"
              class="status-btn"
              :variant="
                currentObj.status.toLowerCase() == 'late'
                  ? 'warning'
                  : 'outline-warning'
              "
              @click="currentObj.status = 'Late'"
            >
              Late
            </b-button>
            <b-button
              pill
              size="sm"
              class="status-btn"
              :variant="currentObj.status == 'H' ? 'info' : 'outline-info'"
              @click="currentObj.status = 'H'"
            >
              H
            </b-button>
            <b-button
              pill
              size="sm"
              class="status-btn"
              :variant="currentObj.status == 'HL' ? 'info' : 'outline-info'"
              @click="currentObj.status = 'HL'"
            >
              HL
            </b-button>
            <b-button
              pill
              size="sm"
              class="status-btn"
              :variant="
                currentObj.status == 'Off' ? 'secondary' : 'outline-secondary'
              "
              @click="currentObj.status = 'Off'"
            >
              Off
            </b-button>
            <b-button
              pill
              size="sm"
              class="status-btn"
              :variant="
                currentObj.status == 'Extra Day' ? 'primary' : 'outline-primary'
              "
              @click="currentObj.status = 'Extra Day'"
            >
              Extra Day
            </b-button>
            <b-button
              pill
              size="sm"
              class="status-btn"
              :variant="currentObj.status == 'WFH' ? 'info' : 'outline-info'"
              @click="currentObj.status = 'WFH'"
            >
              WFH
            </b-button>
          </div>
        </b-col>
      </b-row>

      <b-row
        v-if="!['A', 'L', 'H', 'SL', 'Off'].includes(currentObj.status)"
        class="mb-3"
      >
        <b-col md="6">
          <b-form-group
            :label="$t('Time In')"
            :invalid-feedback="$t('Time In is required')"
            ref="edit_time_in"
          >
            <flat-pickr
              :config="timeConfig"
              v-model="currentObj.timeIn"
              class="form-control"
              :placeholder="$t('Select Time In')"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            :label="$t('Time Out')"
            :invalid-feedback="$t('Time Out is required')"
            ref="edit_time_out"
          >
            <flat-pickr
              :config="timeConfig"
              v-model="currentObj.timeOut"
              class="form-control"
              :placeholder="$t('Select Time Out')"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col class="d-flex justify-content-end">
          <b-button
            @click="saveAtt()"
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="success"
            :disabled="savingAtt"
          >
            <b-spinner v-if="savingAtt" small type="grow" />
            <span v-else class="align-middle">{{ $t("Save") }}</span>
          </b-button>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      id="modal-single-report"
      cancel-variant="outline-secondary"
      hide-footer
      centered
      no-close-on-backdrop
      size="md"
      :title="$t('Attendance Report')"
    >
      <!-- Tab Navigation -->
      <b-tabs v-model="activeReportTab" pills class="mb-3">
        <!-- Monthly Report Tab -->
        <b-tab :title="$t('Monthly Report')" active>
          <b-row class="">
            <b-col md="12">
              <b-form-group
                :label="$t('Month')"
                :invalid-feedback="$t('Month is required')"
                ref="att_month"
              >
                <b-button
                  class="btn-icon mr-50 mb-1"
                  v-for="mon in months"
                  :key="mon.value"
                  :variant="
                    attReport.months.includes(mon.value)
                      ? 'primary'
                      : 'outline-primary'
                  "
                  @click="selectMonth(mon.value)"
                >
                  {{ mon.text.slice(0, 3) }}
                </b-button>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group
                :label="$t('Year')"
                :invalid-feedback="$t('Year is required')"
                ref="att_year"
              >
                <v-select
                  v-model="attReport.year"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="years"
                  :clearable="false"
                  :placeholder="$t('Select year')"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col class="d-flex justify-content-end">
              <b-button
                variant="success"
                class="btn-icon"
                :disabled="reportExporting"
                @click="showSingleReport(false)"
              >
                <span class="align-middle">{{
                  $t("Show Monthly Report")
                }}</span>
              </b-button>
              <b-button
                variant="outline-success"
                class="ml-50"
                :disabled="reportExporting"
                @click="showSingleReport(true)"
              >
                <b-spinner
                  v-if="reportExporting"
                  small
                  type="grow"
                  class="mr-50"
                />
                <feather-icon
                  v-else
                  icon="DownloadIcon"
                  size="16"
                  class="mr-50"
                />
                {{ $t("Excel") }}
              </b-button>
            </b-col>
          </b-row>
        </b-tab>

        <!-- Day Wise Report Tab -->
        <b-tab :title="$t('Day Wise Report')">
          <b-row class="">
            <b-col md="6">
              <b-form-group
                :label="$t('From Date')"
                :invalid-feedback="$t('From Date is required')"
                ref="day_from"
              >
                <flat-pickr
                  :config="config"
                  v-model="dayWiseReport.fromDate"
                  class="form-control"
                  :placeholder="$t('Select From Date')"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label="$t('To Date')"
                :invalid-feedback="$t('To Date is required')"
                ref="day_to"
              >
                <flat-pickr
                  :config="config"
                  v-model="dayWiseReport.toDate"
                  class="form-control"
                  :placeholder="$t('Select To Date')"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col class="d-flex justify-content-end">
              <b-button
                variant="success"
                class="btn-icon"
                :disabled="reportExporting"
                @click="showDayWiseReport(false)"
              >
                <span class="align-middle">{{
                  $t("Show Day Wise Report")
                }}</span>
              </b-button>
              <b-button
                variant="outline-success"
                class="ml-50"
                :disabled="reportExporting"
                @click="showDayWiseReport(true)"
              >
                <b-spinner
                  v-if="reportExporting"
                  small
                  type="grow"
                  class="mr-50"
                />
                <feather-icon
                  v-else
                  icon="DownloadIcon"
                  size="16"
                  class="mr-50"
                />
                {{ $t("Excel") }}
              </b-button>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </b-modal>

    <div v-if="showDetails" class="attendance-view">
      <div class="attendance-view__top">
        <button
          type="button"
          class="deposit-back-btn attendance-back-btn"
          @click="showDetails = false"
        >
          <feather-icon icon="ArrowLeftIcon" size="15" class="mr-50" />
          <span>{{ $t("Back to staff") }}</span>
        </button>
        <div class="attendance-view__actions">
          <span class="attendance-period-pill">
            <feather-icon icon="CalendarIcon" size="14" class="mr-25" />
            {{ attendancePeriodLabel }}
          </span>
          <button
            v-if="
              (attObj &&
                attObj.valueBool &&
                !selectiveTypes.includes(reportDomain)) ||
              onlyIndividual.includes(reportDomain)
            "
            type="button"
            class="attendance-report-btn"
            @click="openSingle()"
          >
            <feather-icon icon="PrinterIcon" size="15" class="mr-50" />
            <span>{{ $t("Show Report") }}</span>
          </button>
        </div>
      </div>

      <div class="attendance-profile">
        <b-avatar
          size="52"
          :src="getPicturePreview(detailObj.picture)"
          variant="light-primary"
          class="attendance-profile__avatar"
          referrerpolicy="no-referrer"
        />
        <div class="attendance-profile__body">
          <h4 class="attendance-profile__name">{{ detailObj.name }}</h4>
          <p class="attendance-profile__meta">
            <span>{{ detailObj.department || "—" }}</span>
            <span class="attendance-profile__dot" aria-hidden="true">·</span>
            <span>{{ detailObj.designation }}</span>
          </p>
          <p
            v-if="detailObj.father_name"
            class="attendance-profile__meta mb-0"
          >
            {{ $t("F/N") }}: {{ detailObj.father_name }}
          </p>
        </div>
      </div>

      <div class="attendance-panel">
        <div class="attendance-panel__section">
          <div class="attendance-panel__head">
            <span class="attendance-panel__title">{{ $t("Period") }}</span>
            <span class="attendance-panel__hint">{{ $t("Month & year") }}</span>
          </div>
          <div class="attendance-toolbar">
            <div class="attendance-toolbar__months">
              <button
                v-for="mon in months"
                :key="mon.value"
                type="button"
                class="attendance-month-chip"
                :class="{ 'is-active': attMonth == mon.value }"
                @click="change(mon.value)"
              >
                {{ mon.text.slice(0, 3) }}
              </button>
            </div>
            <div class="attendance-toolbar__year">
              <v-select
                v-model="attYear"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="years"
                :clearable="false"
                :placeholder="$t('Year')"
                @input="loadAtt()"
              />
            </div>
          </div>
        </div>

        <div
          class="attendance-panel__section attendance-panel__section--legend"
        >
          <div class="attendance-legend" aria-label="Attendance status legend">
            <span
              v-for="item in attendanceStatusLegend"
              :key="item.code"
              class="attendance-legend__item"
              :class="'is-' + item.tone"
            >
              <span class="attendance-legend__chip">{{ item.code }}</span>
              <span class="attendance-legend__label">{{ item.label }}</span>
            </span>
          </div>
        </div>

        <div class="attendance-panel__section">
          <div class="attendance-panel__head">
            <span class="attendance-panel__title">{{
              $t("Month summary")
            }}</span>
            <span class="attendance-panel__hint">{{
              attendancePeriodLabel
            }}</span>
          </div>
          <div
            v-if="dataLoading"
            class="attendance-stats attendance-stats--skeleton"
          >
            <div
              v-for="n in 7"
              :key="`att-stat-skel-${n}`"
              class="attendance-stat-skeleton"
            >
              <div class="attendance-stat-skeleton__value"></div>
              <div class="attendance-stat-skeleton__label"></div>
            </div>
          </div>
          <div v-else class="attendance-stats">
            <div
              v-for="card in attendanceSummaryCards"
              :key="card.key"
              class="attendance-stat"
              :class="'is-' + card.tone"
            >
              <span class="attendance-stat__code">{{ card.code }}</span>
              <span class="attendance-stat__label">{{ card.label }}</span>
              <span class="attendance-stat__value">{{ card.value }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="attendance-calendar">
        <div class="attendance-calendar__card">
          <div
            v-if="dataLoading"
            class="attendance-calendar__loading"
            aria-busy="true"
          >
            <div class="attendance-skeleton">
              <div class="attendance-skeleton__toolbar">
                <div class="attendance-skeleton__title-bar"></div>
              </div>
              <div class="attendance-skeleton__dow">
                <div
                  v-for="d in 7"
                  :key="`att-dow-${d}`"
                  class="attendance-skeleton__dow-cell"
                ></div>
              </div>
              <div
                v-for="n in 5"
                :key="`att-week-${n}`"
                class="attendance-skeleton__week"
              >
                <div
                  v-for="c in 7"
                  :key="`att-day-${n}-${c}`"
                  class="attendance-skeleton__day"
                >
                  <div class="attendance-skeleton__day-num"></div>
                  <div class="attendance-skeleton__event-card">
                    <div class="attendance-skeleton__event-code"></div>
                    <div class="attendance-skeleton__event-line"></div>
                    <div class="attendance-skeleton__event-badge"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="attendance-calendar__body"
            :class="{ 'is-loading': dataLoading }"
          >
            <full-calendar
              ref="refCalendar"
              :options="calendarOptions"
              class="full-calendar attendance-full-calendar"
            >
              <template v-slot:eventContent="arg">
                <div
                  class="att-event-content"
                  :class="[
                    'att-event-content--' + getVariant(arg.event.title),
                    { 'att-event-content--empty': !arg.event.title },
                  ]"
                >
                  <b class="att-event-content__status">{{
                    arg.event.title || "—"
                  }}</b>
                  <span class="att-event-content__title">{{
                    arg.event.title
                      ? attendanceStatusDisplay(arg.event.title)
                      : $t("Not marked — tap to add")
                  }}</span>
                  <div
                    class="att-event-content__times"
                    :class="{
                      'att-event-content__times--empty':
                        !arg.event.extendedProps.timeIn &&
                        !arg.event.extendedProps.timeOut,
                    }"
                  >
                    <p
                      v-if="arg.event.extendedProps.timeIn"
                      class="att-event-content__time mb-25"
                    >
                      <span class="att-event-content__time-label">{{
                        $t("Time in")
                      }}</span>
                      <b-badge
                        :variant="getVariant(arg.event.title)"
                        class="font-small-2"
                      >
                        {{
                          formatAttendanceClock(
                            arg.event.extendedProps.timeIn
                          )
                        }}
                      </b-badge>
                    </p>
                    <p
                      v-if="arg.event.extendedProps.timeOut"
                      class="att-event-content__time mb-0"
                    >
                      <span class="att-event-content__time-label">{{
                        $t("Time out")
                      }}</span>
                      <b-badge
                        :variant="getVariant(arg.event.title)"
                        class="font-small-2"
                      >
                        {{
                          formatAttendanceClock(
                            arg.event.extendedProps.timeOut
                          )
                        }}
                      </b-badge>
                    </p>
                  </div>
                </div>
              </template>
            </full-calendar>
          </div>
        </div>
      </div>
    </div>

      <b-card v-if="false">
        <!-- <b-button
          variant="outline-secondary"
          class="mr-1"
          @click="showDetails = false"
        >
          <feather-icon class="" icon="ArrowLeftIcon" />
          Back
        </b-button> -->
        <b-button
          variant="outline-primary"
          @click="loadDetails('week')"
          class="mr-1"
        >
          {{ $t("This Week") }}
        </b-button>
        <b-button
          variant="outline-primary"
          @click="loadDetails('month')"
          class="mr-1"
        >
          {{ $t("This Month") }}
        </b-button>
        <b-button
          variant="outline-primary"
          @click="loadDetails('year')"
          class="mr-1"
        >
          {{ $t("This Year") }}
        </b-button>
        <b-button
          variant="outline-primary"
          @click="loadDetails('last year')"
          class="mr-1"
        >
          {{ $t("Last Year") }}
        </b-button>

        <b-table
          responsive
          :items="detailItems"
          :fields="detailFields"
          class="mt-1"
          show-empty
          :busy="dataLoading"
        >
          <template #table-busy>
            <div class="d-flex justify-content-center mb-3 mt-3">
              <b-spinner
                style="width: 3rem; height: 3rem"
                variant="primary"
                label="Spinning"
                type="grow"
              ></b-spinner>
            </div>
          </template>
          <template #cell(status)="data">
            <b-badge
              :variant="
                data.value == 'P'
                  ? 'light-success'
                  : data.value == 'A'
                  ? 'light-danger'
                  : data.value == 'L'
                  ? 'light-info'
                  : 'light-warning'
              "
            >
              {{ data.item.status }}
            </b-badge>
          </template>
          <template #cell(date)="data">
            <b-badge variant="light-primary">
              {{
                new Date(data.value).toLocaleDateString("en-UK", {
                  year: "numeric",
                  day: "numeric",
                  month: "short",
                })
              }}
            </b-badge>
          </template>
          <template #cell(timein)="data">
            <b-badge variant="light-primary" v-if="data.item.timeIn">
              {{
                new Intl.DateTimeFormat("en-US", {
                  hour: "numeric",
                  minute: "numeric",
                }).format(new Date(data.item.timeIn))
              }}
            </b-badge>
          </template>
          <template #cell(timeout)="data">
            <b-badge variant="light-primary" v-if="data.item.timeOut">
              {{
                new Intl.DateTimeFormat("en-US", {
                  hour: "numeric",
                  minute: "numeric",
                }).format(new Date(data.item.timeOut))
              }}
            </b-badge>
          </template>
        </b-table>
      </b-card>

    <template v-if="!showDetails">
      <b-row align-h="center" v-if="summLoading" class="mb-2">
        <b-spinner
          style="width: 3rem; height: 3rem"
          variant="primary"
          label="Spinning"
        ></b-spinner>
      </b-row>
      <b-row class="" v-else>
        <b-col xl="2" md="4">
          <b-card body-class="pl-1">
            <b-media no-body>
              <b-media-aside class="mr-50">
                <b-avatar size="44" variant="light-success">
                  <feather-icon size="24" icon="UserCheckIcon" />
                </b-avatar>
              </b-media-aside>
              <b-media-body class="">
                <h4 class="font-weight-bolder mb-0">{{ $t("Present") }}</h4>
                <b-card-text class="mb-0">
                  {{ summaryObj.present }}
                </b-card-text>
              </b-media-body>
            </b-media>
          </b-card>
        </b-col>
        <b-col xl="2" md="4">
          <b-card body-class="pl-1">
            <b-media no-body>
              <b-media-aside class="mr-50">
                <b-avatar size="44" variant="light-danger">
                  <feather-icon size="24" icon="UserXIcon" />
                </b-avatar>
              </b-media-aside>
              <b-media-body class="">
                <h4 class="font-weight-bolder mb-0">{{ $t("Absent") }}</h4>
                <b-card-text class="mb-0">
                  {{ summaryObj.absent }}
                </b-card-text>
              </b-media-body>
            </b-media>
          </b-card>
        </b-col>
        <b-col xl="2" md="4">
          <b-card body-class="pl-1">
            <b-media no-body>
              <b-media-aside class="mr-50">
                <b-avatar size="44" variant="light-info">
                  <feather-icon size="24" icon="PlusCircleIcon" />
                </b-avatar>
              </b-media-aside>
              <b-media-body class="">
                <h4 class="font-weight-bolder mb-0">{{ $t("Leave") }}</h4>
                <b-card-text class="mb-0">
                  {{ summaryObj.leave }}
                </b-card-text>
              </b-media-body>
            </b-media>
          </b-card>
        </b-col>
        <b-col xl="2" md="4">
          <b-card body-class="pl-1">
            <b-media no-body>
              <b-media-aside class="mr-50">
                <b-avatar size="44" variant="light-danger">
                  <feather-icon size="24" icon="InfoIcon" />
                </b-avatar>
              </b-media-aside>
              <b-media-body v-if="reportDomain == 'myskoolalhameed'">
                <h4 class="font-weight-bolder mb-0">{{ $t("Half Day") }}</h4>
                <b-card-text class="mb-0">
                  {{ summaryObj.halfdays }}
                </b-card-text>
              </b-media-body>
              <b-media-body v-else>
                <h4 class="font-weight-bolder mb-0">{{ $t("Short Leave") }}</h4>
                <b-card-text class="mb-0">
                  {{ summaryObj.shortLeave }}
                </b-card-text>
              </b-media-body>
            </b-media>
          </b-card>
        </b-col>
        <b-col xl="2" md="4">
          <b-card body-class="pl-1">
            <b-media no-body>
              <b-media-aside class="mr-50">
                <b-avatar size="44" variant="light-warning">
                  <feather-icon size="24" icon="ClockIcon" />
                </b-avatar>
              </b-media-aside>
              <b-media-body class="">
                <h4 class="font-weight-bolder mb-0">{{ $t("Late") }}</h4>
                <b-card-text class="mb-0">
                  {{ summaryObj.late }}
                </b-card-text>
              </b-media-body>
            </b-media>
          </b-card>
        </b-col>
        <b-col xl="2" md="4">
          <b-card body-class="pl-1">
            <b-media no-body>
              <b-media-aside class="mr-50">
                <b-avatar size="44" variant="light-primary">
                  <feather-icon size="24" icon="CloudIcon" />
                </b-avatar>
              </b-media-aside>
              <b-media-body class="">
                <h4 class="font-weight-bolder mb-0">{{ $t("Holidays") }}</h4>
                <b-card-text class="mb-0">
                  {{ summaryObj.holidays }}
                </b-card-text>
              </b-media-body>
            </b-media>
          </b-card>
        </b-col>
      </b-row>

      <b-card>
        <b-row class="align-items-center">
          <b-col lg="3" md="4">
            <b-form-group
              :label="$t('Department')"
              :invalid-feedback="$t('Department is required')"
              ref="dep"
            >
              <v-select
                multiple
                :closeOnSelect="false"
                v-model="myObj.depIDs"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="departments"
                :reduce="(val) => val.id"
                label="name"
                :clearable="false"
                :placeholder="$t('Select department')"
                @input="setGridDept()"
              />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group
              :label="$t('Date')"
              :invalid-feedback="$t('Date is required')"
              ref="date"
            >
              <flat-pickr
                :config="config"
                v-model="myObj.date"
                class="form-control"
                :placeholder="$t('Select Date')"
                @on-change="checkDate()"
              />
            </b-form-group>
          </b-col>
          <b-button
            class="ml-1"
            :disabled="gridLoading"
            variant="primary"
            @click="loadgrid()"
          >
            <!-- @click="updateLate()" -->
            {{ $t("Show") }}
          </b-button>
          <b-button
            v-if="rights.add || rights.edit"
            variant="success"
            class="ml-1"
            :disabled="saving"
            @click="save()"
          >
            {{ $t("Save") }}
          </b-button>
          <b-button
            v-if="rights.add || rights.edit"
            variant="success"
            class="ml-1"
            :disabled="saving"
            @click="openHoliday()"
          >
            {{ $t("Mark Holiday") }}
          </b-button>
          <b-button
            v-if="rights.add || rights.edit"
            variant="outline-primary"
            class="ml-1"
            :disabled="markingSunday"
            @click="openSundayModal()"
          >
            {{ $t("Mark Sunday") }}
          </b-button>
          <!-- <b-button
            v-if="rights.add || rights.edit"
            variant="info"
            class="ml-1"
            :disabled="saving"
            @click="openUpdateAll()"
          >
            Update All
          </b-button> -->
          <b-dropdown
            v-if="
              (rights.add || rights.edit) &&
              showFaceId &&
              showFaceId.value === 'true'
            "
            variant="success"
            class="ml-1"
            :disabled="saving"
            split
            @click="openFaceAttendance()"
          >
            <template #button-content>
              <feather-icon icon="CameraIcon" class="mr-50" />
              <span>{{ $t("Face Attendance") }}</span>
            </template>

            <b-dropdown-item @click="copyFaceAttendanceLink">
              <feather-icon icon="CopyIcon" class="mr-50" />
              <span>{{ $t("Copy Link") }}</span>
            </b-dropdown-item>
          </b-dropdown>
          <b-button
            class="ml-1 btn-icon"
            variant="outline-primary"
            v-b-tooltip.hover.top
            :title="$t('Filter')"
            @click="$bvModal.show('modal-filter')"
          >
            <feather-icon icon="FilterIcon" />
          </b-button>
          <b-button
            class="ml-1 btn-icon"
            variant="outline-primary"
            v-b-tooltip.hover.top
            :title="$t('Reports')"
            @click="openReport()"
          >
            <feather-icon icon="BarChart2Icon" />
          </b-button>
          <b-button
            class="ml-1 btn-icon"
            variant="outline-primary"
            v-b-tooltip.hover.top
            :title="$t('Settings')"
            @click="visibility3 = true"
            :disabled="settLoading"
          >
            <b-spinner v-if="settLoading" small />
            <feather-icon v-else icon="SettingsIcon" />
          </b-button>
          <b-button
            v-if="rights.delete"
            variant="outline-danger"
            class="ml-1 btn-icon"
            v-b-tooltip.hover.top
            :title="$t('Delete')"
            @click="DeleteAtt()"
            :disabled="deleting"
          >
            <feather-icon icon="Trash2Icon" />
          </b-button>
          <b-button
            v-if="selectedStaff.length > 0"
            variant="outline-warning"
            class="ml-1"
            v-b-tooltip.hover.top
            :title="$t('Update Selected')"
            @click="openBulkUpdate()"
          >
            <feather-icon icon="EditIcon" class="mr-50" />
            {{ $t("Update") }}
          </b-button>
          <!-- <b-button
            class="ml-1 btn-icon"
            variant="outline-primary"
            v-b-tooltip.hover.top
            title="Messages"
            @click="openMessage()"
          >
            <feather-icon icon="MailIcon" />
          </b-button> -->
        </b-row>

        <b-row class="mt-1" v-if="showGrid">
          <b-col md="12">
            <b-form-input
              v-model="searchQuery"
              class="d-inline-block"
              :placeholder="$t('Search by name')"
            />
          </b-col>
          <b-col>
            <b-table
              class="mt-1"
              :items="filters"
              :fields="computedFields"
              show-empty
              :busy="gridLoading || saving"
              responsive
              hover
              small
              selectable
              select-mode="single"
              @row-selected="openDetail($event[0])"
              @head-clicked="handleSort"
            >
              <template #table-busy>
                <div class="d-flex justify-content-center mb-3 mt-3">
                  <b-spinner
                    style="width: 3rem; height: 3rem"
                    type="grow"
                    variant="primary"
                    label="Spinning"
                  ></b-spinner>
                </div>
              </template>

              <template #head()="data">
                {{ $t(data.label) }}
              </template>

              <template #head(selected)>
                <b-form-checkbox
                  v-model="selectAll"
                  @change="toggleSelectAll"
                />
              </template>

              <template #cell(selected)="data">
                <b-form-checkbox
                  v-model="selectedStaff"
                  :value="data.item.id"
                  @change="onSelectionChange"
                />
              </template>

              <template #cell(index)="data">
                <b-badge variant="light-primary">
                  {{ gridData.indexOf(data.item) + 1 }}
                </b-badge>
              </template>
              <template #cell(id)="data">
                <b-badge variant="light-primary">
                  {{ data.item.id }}
                </b-badge>
              </template>
              <template #cell(rfID)="data">
                <b-badge variant="light-primary">
                  {{ data.item.rfID }}
                </b-badge>
              </template>
              <template #cell(name)="data">
                <b-badge variant="light-primary">
                  {{ data.item.name }}
                </b-badge>
              </template>

              <template #cell(father_name)="data">
                <b-badge variant="light-primary">
                  {{ data.item.father_name }}
                </b-badge>
              </template>

              <template #cell(designation)="data">
                <b-badge variant="light-primary">
                  {{ data.item.designation }}
                </b-badge>
              </template>

              <template #cell(department)="data">
                <b-badge variant="light-primary">
                  {{ data.item.department }}
                </b-badge>
              </template>
              <template #cell(timein)="data">
                <b-badge
                  variant="light-primary"
                  v-if="data.item.obj.timeIn"
                  @click.stop="
                    (rights.add || rights.edit) && (data.item.obj.timeIn = null)
                  "
                >
                  {{
                    new Intl.DateTimeFormat("en-US", {
                      hour: "numeric",
                      minute: "numeric",
                    }).format(new Date(data.item.obj.timeIn))
                  }}
                </b-badge>
                <b-form-group
                  v-else-if="rights.add || rights.edit"
                  class="mb-0"
                >
                  <b-input-group>
                    <flat-pickr
                      :config="{
                        enableTime: true,
                        noCalendar: true,
                        altFormat: 'h:i K',
                        altInput: true,
                        dateFormat: 'Y-m-d\\TH:i:S',
                        defaultHour: 8,
                      }"
                      v-model="filters[data.index].inputTimein"
                      class="form-control"
                    />
                    <b-input-group-append
                      is-text
                      @click.stop="filters[data.index].inputTimein = null"
                      v-b-tooltip.hover.top
                      :title="$t('Clear')"
                    >
                      <feather-icon
                        class="cursor-pointer"
                        size="16"
                        icon="XIcon"
                      />
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </template>
              <template #cell(timeout)="data">
                <b-badge
                  variant="light-primary"
                  v-if="data.item.obj.timeOut"
                  @click.stop="
                    (rights.add || rights.edit) &&
                      (data.item.obj.timeOut = null)
                  "
                >
                  {{
                    new Intl.DateTimeFormat("en-US", {
                      hour: "numeric",
                      minute: "numeric",
                    }).format(new Date(data.item.obj.timeOut))
                  }}
                </b-badge>
                <b-form-group
                  v-else-if="rights.add || rights.edit"
                  class="mb-0"
                >
                  <b-input-group>
                    <flat-pickr
                      :config="{
                        enableTime: true,
                        noCalendar: true,
                        altFormat: 'h:i K',
                        altInput: true,
                        dateFormat: 'Y-m-d\\TH:i:S',
                        defaultHour: 12,
                      }"
                      v-model="filters[data.index].inputTimeout"
                      class="form-control"
                    />
                    <b-input-group-append
                      is-text
                      @click.stop="filters[data.index].inputTimeout = null"
                      v-b-tooltip.hover.top
                      :title="$t('Clear')"
                    >
                      <feather-icon
                        class="cursor-pointer"
                        size="16"
                        icon="XIcon"
                      />
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </template>

              <!-- <template #cell(profile)="data">
                      <b-avatar
                        size="36"
                        class=""
                        variant="primary"
                        :src="data.item.picture"
                      />
                    </template> -->
              <template #cell(status)="data">
                <div class="d-flex align-items-center">
                  <b-button
                    pill
                    size="sm"
                    style="margin-inline: 2px"
                    :variant="
                      data.item.obj.status == 'P'
                        ? 'success'
                        : 'outline-success'
                    "
                    :disabled="!rights.add && !rights.edit"
                    @click="changeAtt(data.index, 'P')"
                  >
                    P
                  </b-button>
                  <b-button
                    pill
                    size="sm"
                    style="margin-inline: 2px"
                    :variant="
                      data.item.obj.status == 'A' ? 'danger' : 'outline-danger'
                    "
                    :disabled="!rights.add && !rights.edit"
                    @click="changeAtt(data.index, 'A')"
                  >
                    A
                  </b-button>
                  <b-button
                    v-if="doubleObj.valueBool == true"
                    pill
                    size="sm"
                    style="margin-inline: 2px"
                    :variant="
                      data.item.obj.status == 'AA' ? 'danger' : 'outline-danger'
                    "
                    :disabled="!rights.add && !rights.edit"
                    @click="changeAtt(data.index, 'AA')"
                  >
                    AA
                  </b-button>
                  <b-button
                    pill
                    size="sm"
                    style="margin-inline: 2px"
                    :variant="
                      data.item.obj.status == 'L' ? 'info' : 'outline-info'
                    "
                    :disabled="!rights.add && !rights.edit"
                    @click="changeAtt(data.index, 'L')"
                  >
                    L
                  </b-button>
                  <b-button
                    pill
                    size="sm"
                    style="margin-inline: 2px"
                    :variant="
                      data.item.obj.status == 'SL' ? 'info' : 'outline-info'
                    "
                    :disabled="!rights.add && !rights.edit"
                    @click="changeAtt(data.index, 'SL')"
                  >
                    SL
                  </b-button>
                  <b-button
                    pill
                    size="sm"
                    style="margin-inline: 2px"
                    :variant="
                      data.item.obj.status.toLowerCase() == 'late'
                        ? 'warning'
                        : 'outline-warning'
                    "
                    :disabled="!rights.add && !rights.edit"
                    @click="changeAtt(data.index, 'Late')"
                  >
                    Late
                  </b-button>
                  <b-button
                    pill
                    size="sm"
                    style="margin-inline: 2px"
                    :variant="
                      data.item.obj.status == 'H' ? 'info' : 'outline-info'
                    "
                    :disabled="!rights.add && !rights.edit"
                    @click="changeAtt(data.index, 'H')"
                  >
                    H
                  </b-button>
                  <b-button
                    pill
                    size="sm"
                    style="margin-inline: 2px"
                    :variant="
                      data.item.obj.status == 'HL' ? 'info' : 'outline-info'
                    "
                    :disabled="!rights.add && !rights.edit"
                    @click="changeAtt(data.index, 'HL')"
                  >
                    HL
                  </b-button>
                  <b-button
                    pill
                    size="sm"
                    style="margin-inline: 2px"
                    :variant="
                      data.item.obj.status == 'Off'
                        ? 'secondary'
                        : 'outline-secondary'
                    "
                    :disabled="!rights.add && !rights.edit"
                    @click="changeAtt(data.index, 'Off')"
                  >
                    Off
                  </b-button>
                  <b-button
                    pill
                    size="sm"
                    style="margin-inline: 2px"
                    :variant="
                      data.item.obj.status == 'Extra Day'
                        ? 'primary'
                        : 'outline-primary'
                    "
                    :disabled="!rights.add && !rights.edit"
                    @click="changeAtt(data.index, 'Extra Day')"
                  >
                    Extra Day
                  </b-button>
                  <b-button
                    pill
                    size="sm"
                    style="margin-inline: 2px"
                    :variant="
                      data.item.obj.status == 'WFH' ? 'info' : 'outline-info'
                    "
                    :disabled="!rights.add && !rights.edit"
                    @click="changeAtt(data.index, 'WFH')"
                  >
                    WFH
                  </b-button>
                </div>
              </template>
            </b-table>
          </b-col>
        </b-row>
      </b-card>
    </template>

    <!-- Filter Modal -->
    <b-modal
      id="modal-filter"
      cancel-variant="outline-secondary"
      hide-footer
      centered
      no-close-on-backdrop
      :title="$t('Filter Options')"
    >
      <b-form-group
        :label="$t('Appointed Date From')"
        :invalid-feedback="$t('Date is required')"
        ref="appointed_from"
      >
        <flat-pickr
          :config="config"
          v-model="filter.appointedFrom"
          class="form-control"
          :placeholder="$t('Select Date')"
        />
      </b-form-group>

      <b-form-group
        :label="$t('Appointed Date To')"
        :invalid-feedback="$t('Date is required')"
        ref="appointed_to"
      >
        <flat-pickr
          :config="config"
          v-model="filter.appointedTo"
          class="form-control"
          :placeholder="$t('Select Date')"
        />
      </b-form-group>

      <b-form-group
        :label="$t('Designation')"
        :invalid-feedback="$t('Designation is required')"
        ref="designation"
      >
        <b-form-input
          v-model="filter.designation"
          :placeholder="$t('Enter designation')"
        />
      </b-form-group>

      <b-row class="mt-2">
        <b-col class="d-flex justify-content-end">
          <b-button
            @click="resetFilters()"
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            class="mr-2"
          >
            <span class="align-middle">{{ $t("Reset") }}</span>
          </b-button>
          <b-button
            @click="applyFilters()"
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="primary"
          >
            <span class="align-middle">{{ $t("Apply Filters") }}</span>
          </b-button>
        </b-col>
      </b-row>
    </b-modal>

    <!-- Bulk Update Modal -->
    <b-modal
      id="modal-bulk-update"
      cancel-variant="outline-secondary"
      hide-footer
      centered
      no-close-on-backdrop
      :title="$t('Update Selected Staff')"
    >
      <div class="mb-3">
        <strong
          >{{ $t("Selected Staff") }} ({{ selectedStaff.length }}):</strong
        >
        <div
          class="mt-2"
          style="
            max-height: 120px;
            overflow-y: auto;
            border: 1px solid #e0e6ed;
            border-radius: 4px;
            padding: 8px;
          "
        >
          <b-badge
            v-for="staffId in selectedStaff"
            :key="staffId"
            variant="light-primary"
            class="mr-1 mb-1"
          >
            {{ getStaffName(staffId) }}
          </b-badge>
        </div>
      </div>

      <b-form-group
        :label="$t('Date Range')"
        :invalid-feedback="$t('Date range is required')"
        ref="bulk_date_range"
      >
        <flat-pickr
          :config="config2"
          v-model="bulkUpdateObj.dateRange"
          class="form-control"
          :placeholder="$t('Select Date Range')"
        />
      </b-form-group>

      <b-form-group
        :label="$t('Time In')"
        :invalid-feedback="$t('Time In is required')"
        ref="bulk_time_in"
      >
        <flat-pickr
          :config="timeConfig"
          v-model="bulkUpdateObj.timeIn"
          class="form-control"
          :placeholder="$t('Select Time In')"
        />
      </b-form-group>

      <b-form-group
        :label="$t('Time Out')"
        :invalid-feedback="$t('Time Out is required')"
        ref="bulk_time_out"
      >
        <flat-pickr
          :config="timeConfig"
          v-model="bulkUpdateObj.timeOut"
          class="form-control"
          :placeholder="$t('Select Time Out')"
        />
      </b-form-group>

      <b-row class="mt-2">
        <b-col class="d-flex justify-content-end">
          <b-button
            @click="$bvModal.hide('modal-bulk-update')"
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            class="mr-2"
          >
            <span class="align-middle">{{ $t("Cancel") }}</span>
          </b-button>
          <b-button
            @click="saveBulkUpdate()"
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="primary"
            :disabled="bulkUpdating"
          >
            <b-spinner v-if="bulkUpdating" small class="mr-1" />
            <span class="align-middle">{{ $t("Update") }}</span>
          </b-button>
        </b-col>
      </b-row>
    </b-modal>

    <!-- Update All Modal -->
    <b-modal
      id="modal-update-all"
      cancel-variant="outline-secondary"
      hide-footer
      centered
      no-close-on-backdrop
      :title="$t('Update All Attendance')"
    >
      <b-row class="">
        <b-col md="12">
          <b-form-group
            :label="$t('Month')"
            :invalid-feedback="$t('Month is required')"
            ref="update_month"
          >
            <v-select
              v-model="updateAllObj.month"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="months"
              :reduce="(val) => val.value"
              label="text"
              :clearable="false"
              placeholder="Select Month"
            />
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group
            label="Year"
            invalid-feedback="Year is required."
            ref="update_year"
          >
            <v-select
              v-model="updateAllObj.year"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="years"
              :clearable="false"
              placeholder="Select Year"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col class="d-flex justify-content-end">
          <b-button
            @click="$bvModal.hide('modal-update-all')"
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            class="mr-2"
          >
            <span class="align-middle">{{ $t("Cancel") }}</span>
          </b-button>
          <b-button
            @click="updateAllAttendance()"
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="primary"
            :disabled="updatingAll"
          >
            <b-spinner v-if="updatingAll" small class="mr-1" />
            <span class="align-middle">{{ $t("Update") }}</span>
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { required, minLength, between } from "vuelidate/lib/validators";
import {
  BAvatar,
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BImg,
  VBTooltip,
  BFormCheckbox,
  BFormGroup,
  BForm,
  BMediaAside,
  BMediaBody,
  BAside,
  BSpinner,
  BCardTitle,
  BCardText,
  BSidebar,
  VBToggle,
  BInputGroup,
  BInputGroupAppend,
  BTabs,
  BTab,
  BPagination,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { mapActions, mapGetters } from "vuex";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";

import axios from "axios";
import { getMediaPreviewUrl } from "@/utils/gdriveUpload";

export default {
  components: {
    BAvatar,
    BMedia,
    BMediaBody,
    BMediaAside,
    BCard,
    BRow,
    BBadge,
    BTable,
    BCol,
    BFormInput,
    BButton,
    BSidebar,
    BFormGroup,
    BInputGroup,
    BFormCheckbox,
    BForm,
    BSpinner,
    BDropdown,
    BDropdownItem,
    BLink,
    vSelect,
    flatPickr,
    BInputGroupAppend,
    FullCalendar,
    BTabs,
    BTab,
    BPagination,
  },
  props: {},
  directives: {
    "b-tooltip": VBTooltip,
    "b-toggle": VBToggle,
    Ripple,
  },
  async created() {
    let right = {};
    this.$store.state.menu.forEach((el) => {
      el.children.forEach((ch) => {
        right[ch.route] = {
          view: ch.view,
          add: ch.add,
          edit: ch.edit,
          delete: ch.delete,
        };
      });
    });
    // console.log(right);
    this.$store.commit("setRights", right);

    if (!this.$store.state.rights[this.$route.name]) {
      // console.log(this.$store.state.rights[this.$route.name]);
      this.$router.replace({
        name: "misc-not-authorized",
      });
    } else {
      this.rights = this.$store.state.rights[this.$route.name];
      this.LoadInfo();
      this.loadAttSettings();
      this.LoadSettings();
      this.LoadSettingsAll();
      this.loadgrid();
    }
  },
  computed: {
    filteredOptions() {
      if (this.selectiveTypes.includes(this.reportDomain)) {
        return this.reportOptions.filter((option) =>
          ["general", "summary"].includes(option.value)
        );
      }
      return this.reportOptions;
    },
    shouldShowHolidayCampusDropdown() {
      return Number(this.$store.state.userData?.cId) === 1;
    },
    holidayCampusOptions() {
      return [
        { id: 0, branch: this.$t("All Campuses") },
        ...(this.holidayCampuses || []),
      ];
    },
    filters: function () {
      return this.gridData.filter((pro) => {
        return pro.name.toLowerCase().match(this.searchQuery.toLowerCase());
      });
    },
    // Computed property for fields with sorting functionality
    computedFields() {
      const baseFields =
        this.mode == "biometric" ? this.bioFields : this.fields;

      if (this.reportDomain == "myskooliuss") {
        let obj = baseFields.find((f) => f.key == "father_name");
        if (obj) {
          obj.key = "designation";
          obj.label = "Designation";
        }
      }
      return baseFields;
    },
    holidaySummarySkippedDepartments() {
      const list = this.holidaySummary?.skippedDepartments;
      return Array.isArray(list) ? list : [];
    },
    holidaySummaryCampusRows() {
      const list = this.holidaySummary?.campusSummaries;
      if (!Array.isArray(list)) return [];
      return list.filter((c) => c.staffCount > 0);
    },
    holidaySummarySkippedCount() {
      const skippedStaff = Number(this.holidaySummary?.skippedStaff) || 0;
      const skippedDeps = this.holidaySummarySkippedDepartments.length;
      return skippedStaff + skippedDeps;
    },
    holidaySummaryHasSkips() {
      return this.holidaySummarySkippedCount > 0;
    },
    holidaySummaryTotalProcessed() {
      const s = this.holidaySummary || {};
      if (s.totalProcessed != null && s.totalProcessed !== "") {
        return s.totalProcessed;
      }
      return (
        (Number(s.created) || 0) +
        (Number(s.updated) || 0) +
        (Number(s.alreadyHoliday) || 0)
      );
    },
    holidayHistoryRange() {
      const total = this.holidayHistoryTotal || 0;
      if (!total) return { start: 0, end: 0 };
      const start =
        (this.holidayHistoryPage - 1) * this.holidayHistoryPageSize + 1;
      const end = Math.min(
        this.holidayHistoryPage * this.holidayHistoryPageSize,
        total
      );
      return { start, end };
    },
    holidayHistoryStatusFilterOptions() {
      const base = [{ label: this.$t("All types"), value: "" }];
      const fromApi = this.holidayHistoryStatusOptions || [];
      if (fromApi.length) return base.concat(fromApi);
      return base.concat(this.defaultHolidayHistoryStatusOptions);
    },
    showHolidayHistoryCampusColumn() {
      return Number(this.getHolidayHistoryCampusId()) === 0;
    },
    visibleHolidayHistoryFields() {
      const fields = this.holidayHistoryFields || [];
      if (this.showHolidayHistoryCampusColumn) return fields;
      return fields.filter((f) => f.key !== "campusName");
    },
    attendanceStatusLegend() {
      const items = [
        { code: "P", label: "Present", tone: "success" },
        { code: "A", label: "Absent", tone: "danger" },
        { code: "AA", label: "Double absent", tone: "danger" },
        { code: "L", label: "Leave", tone: "info" },
        { code: "SL", label: "Short leave", tone: "info" },
        { code: "H", label: "Holiday", tone: "info" },
        { code: "HL", label: "Half leave", tone: "info" },
        { code: "Late", label: "Late", tone: "warning" },
        { code: "Off", label: "Off day", tone: "secondary" },
        { code: "Extra Day", label: "Extra day", tone: "primary" },
        { code: "WFH", label: "Work from home", tone: "info" },
      ];
      if (!this.doubleObj || !this.doubleObj.valueBool) {
        return items.filter((item) => item.code !== "AA");
      }
      return items;
    },
    attendancePeriodLabel() {
      const month = (this.months || []).find(
        (m) => Number(m.value) === Number(this.attMonth)
      );
      const name = month ? month.text : "";
      const year = this.attYear || "";
      return [name, year].filter(Boolean).join(" ");
    },
    attendanceSummaryCards() {
      const s = this.countObj || {};
      const shortLabel =
        this.reportDomain === "myskoolalhameed" ? "Half day" : "Short leave";
      const shortVal =
        this.reportDomain === "myskoolalhameed" ? s.halfdays : s.shortLeave;

      const cards = [
        {
          key: "present",
          code: "P",
          label: "Present",
          tone: "present",
          value: s.present,
        },
        {
          key: "absent",
          code: "A",
          label: "Absent",
          tone: "absent",
          value: s.absent,
        },
        {
          key: "leave",
          code: "L",
          label: "Leave",
          tone: "leave",
          value: s.leave,
        },
        {
          key: "short",
          code: "SL",
          label: shortLabel,
          tone: "short",
          value: shortVal,
        },
        {
          key: "late",
          code: "Late",
          label: "Late",
          tone: "late",
          value: s.late,
        },
        {
          key: "holiday",
          code: "H",
          label: "Holiday",
          tone: "holiday",
          value: this.attendanceSummaryHolidayCount(),
        },
        {
          key: "off",
          code: "Off",
          label: "Off day",
          tone: "off",
          value: this.attendanceSummaryOffCount(),
        },
      ];

      return cards.map((card) => ({
        ...card,
        value: Number(card.value) || 0,
      }));
    },
    attendanceModalTitle() {
      const id = Number(this.currentObj && this.currentObj.id);
      if (!id || id <= 0) {
        return this.$t("Add Attendance");
      }
      return this.$t("Edit Attendance");
    },
  },
  data() {
    let yList = [];
    for (let i = 2020; i <= 2040; i++) {
      yList.push(i);
    }
    return {
      calendarOptions: {
        plugins: [dayGridPlugin, interactionPlugin],
        initialView: "dayGridMonth",
        headerToolbar: {
          start: "title",
          end: "",
        },
        events: [
          // { title: "P", start: new Date() },
          // { title: "A", start: "2024-03-05T00:00:00" },
        ],
        eventResizableFromStart: true,
        dragScroll: true,
        dayMaxEvents: 1,
        // navLinks: true,
        eventClassNames({ event: e }) {
          const colorName =
            e.title == "P"
              ? "success"
              : e.title == "A" || e.title == "AA"
              ? "danger"
              : ["L", "H", "SL", "HL", "WFH"].includes(e.title)
              ? "info"
              : e.title == "Off"
              ? "secondary"
              : e.title == "Extra Day"
              ? "primary"
              : "warning";

          return [`text-${colorName}`, "att-fc-event-shell"];
        },
        eventClick: this.openEditAtt,
        dateClick: this.onAttendanceDayClick,
        eventDidMount: this.stripAttendanceEventShell,
      },
      attMonth: new Date().getMonth() + 1,
      attYear: new Date().getFullYear(),
      currentObj: {
        status: "",
        timeIn: null,
        timeOut: null,
      },
      savingAtt: false,
      reportDomain: this.$store.state.report.replace(/_/g, ""),
      rights: {},
      config: {
        altFormat: "j M, Y",
        altInput: true,
        dateFormat: "Y-m-d",
        mode: "single",
      },
      config2: {
        altFormat: "j M, Y",
        altInput: true,
        dateFormat: "Y-m-d",
        mode: "range",
      },
      statusOptions: [
        { name: "All", value: "" },
        { name: "Present", value: "P" },
        { name: "Absent", value: "A" },
        { name: "Leave", value: "L" },
        { name: "Late", value: "Late" },
      ],
      request: false,
      exporting: false,
      saving: false,
      colorDep: [],
      visibility2: false,

      sidebarTitle: "Add Balance",
      sidebarButton: "Save",
      buttonIcon: "PlusIcon",
      dataLoading: false,

      visibility: false,
      logoloading: "",
      searchQuery: "",
      currentPage: 1,
      perPage: 30,
      totalRows: 0,
      index: null,

      fields: [
        {
          label: "",
          key: "selected",
          thClass: "text-center",
          tdClass: "text-center",
        },
        { label: "S.No", key: "index" },
        { label: "RFID", key: "rfID" },
        { label: "Name", key: "name", sortable: true },
        { label: "Father Name", key: "father_name" },
        { label: "Status", key: "status" },
      ],
      bioFields: [
        {
          label: "",
          key: "selected",
          thClass: "text-center",
          tdClass: "text-center",
        },
        { label: "S.No", key: "index" },
        { label: "RFID", key: "rfID" },
        { label: "Name", key: "name", sortable: true },
        { label: "Father Name", key: "father_name" },
        { label: "Time in", key: "timein" },
        { label: "Time out", key: "timeout" },
        { label: "Status", key: "status" },
      ],
      items: [],
      gridData: [],
      departments: [{ name: "All Departments", id: 0 }],
      mode: null,
      repObj: {
        date: "",
        depIDs: [0],
        status: [],
      },
      dIDs: [0],
      repDate: "",
      repSingleDate: "",
      depText: "Department",
      selected: null,
      rangeDate: null,
      myObj: {
        date: new Date().toJSON().split("T")[0],
        depIDs: [0],
      },
      depObj: {
        id: 0,
        name: "",
        campusID: this.$store.state.userData.cId,
      },
      detailObj: {},
      timeout: 10000,
      msgObj: {
        dt: "",
        depIDs: [0],
        status: "",
      },
      msgIDs: [0],
      showGrid: false,
      gridLoading: false,
      visibility3: false,
      notiTeacher: {},
      notiManager: {},
      doubleObj: {},
      settLoading: false,
      vueTelOptions: { placeholder: this.$t("Enter contact number") },
      dropOptions: {
        disabled: false,
        showDialCodeInList: true,
        showFlags: true,
      },
      phoneerror: false,
      savingSettings: false,
      attSettings: {
        id: 0,
        campusID: this.$store.state.userData.cId,
        notifyArrival: false,
        notifyDeparture: false,
        showDues: false,
        showRecent: false,
        autoHide: false,
        hideAfterSeconds: 5,
        attendanceMode: "",
      },
      showDetails: false,
      otherLoading: false,
      detailItems: [],
      detailFields: [
        { label: "Date", key: "date" },
        { label: "Status", key: "status" },
        { label: "Time in", key: "timein" },
        { label: "Time out", key: "timeout" },
      ],
      detailBioFields: [
        { label: "S.No", key: "index" },
        { label: "Date", key: "date" },
        { label: "Time in", key: "timein" },
        { label: "Time out", key: "timeout" },
        { label: "Status", key: "status" },
      ],
      savingOther: false,
      countObj: {
        present: 0,
        absent: 0,
        leave: 0,
        late: 0,
        halfdays: 0,
      },
      summaryObj: {
        present: 0,
        absent: 0,
        leave: 0,
        late: 0,
        holidays: 0,
        suspended: 0,
        shortLeave: 0,
        halfdays: 0,
      },
      summLoading: false,
      months: [
        { text: "January", value: 1 },
        { text: "February", value: 2 },
        { text: "March", value: 3 },
        { text: "April", value: 4 },
        { text: "May", value: 5 },
        { text: "June", value: 6 },
        { text: "July", value: 7 },
        { text: "August", value: 8 },
        { text: "September", value: 9 },
        { text: "October", value: 10 },
        { text: "November", value: 11 },
        { text: "December", value: 12 },
      ],
      years: yList,
      deleting: false,
      holiObj: {
        dtFrom: "",
        dtTo: "",
        campusIDs: [0],
        departmentIDs: [0],
        reason: "",
      },
      holidayCampuses: [],
      holidayDepartments: [{ name: "All Departments", id: 0 }],
      visibility4: false,
      holiDate: "",
      marking: false,
      holidaySummaryVisible: false,
      holidaySummary: null,
      holidaySummaryCampusFields: [
        { key: "campusName", label: "Campus" },
        { key: "staffCount", label: "Staff" },
        { key: "created", label: "Created" },
        { key: "updated", label: "Updated" },
        { key: "totalMarked", label: "Total Marked" },
      ],
      holidayHistoryVisible: false,
      holidayHistoryLoading: false,
      holidayHistoryDeletingId: null,
      holidayHistoryItems: [],
      holidayHistoryPage: 1,
      holidayHistoryPageSize: 50,
      holidayHistoryTotal: 0,
      holidayHistoryFilters: {
        dtFrom: "",
        dtTo: "",
        status: "",
      },
      holidayHistoryStatusOptions: [],
      defaultHolidayHistoryStatusOptions: [
        { label: "Holiday (H)", value: "H" },
        { label: "Exam Leave (EXL)", value: "EXL" },
        { label: "Study Leave (STL)", value: "STL" },
        { label: "Off", value: "Off" },
      ],
      holidayHistoryFields: [
        {
          key: "campusName",
          label: "Campus",
          thClass: "hh-th",
          tdClass: "hh-td",
        },
        { key: "status", label: "Status", thClass: "hh-th", tdClass: "hh-td" },
        { key: "dtFrom", label: "From", thClass: "hh-th", tdClass: "hh-td" },
        { key: "dtTo", label: "To", thClass: "hh-th", tdClass: "hh-td" },
        { key: "reason", label: "Reason", thClass: "hh-th", tdClass: "hh-td" },
        {
          key: "departmentIDs",
          label: "Departments",
          thClass: "hh-th",
          tdClass: "hh-td",
        },
        {
          key: "createdByName",
          label: "Created By",
          thClass: "hh-th",
          tdClass: "hh-td",
        },
        {
          key: "createdAt",
          label: "Created At",
          thClass: "hh-th",
          tdClass: "hh-td",
        },
        {
          key: "actions",
          label: "",
          thClass: "hh-th hh-th-actions",
          tdClass: "hh-td hh-td-actions",
        },
      ],
      visibilitySunday: false,
      markingSunday: false,
      sundayObj: {
        date: "",
      },
      singleObj: {
        dtFrom: null,
        dtTo: null,
      },
      showFaceId: false,
      reportType: "general",
      reportOptions: [
        { text: "General", value: "general" },
        { text: "Time in", value: "timein-report" },
        { text: "Late / Absent", value: "late-report" },
        { text: "Summary", value: "summary" },
      ],
      singleVisible: ["late-report", "timein-report"], // reports that have single date
      selectiveTypes: ["myskoolveritas", "myskoolhhpublic"],
      onlyIndividual: [
        "myskoolalhameed",
        "myskooldeenway",
        "myskoolveritas",
        "myskoolascend",
      ],
      attObj: null,
      attReport: {
        months: [],
        year: new Date().getFullYear(),
      },
      filter: {
        appointedFrom: null,
        appointedTo: null,
        designation: "",
      },
      selectedStaff: [],
      bulkUpdateObj: {
        date: null,
        dateRange: null,
        timeIn: null,
        timeOut: null,
      },
      timeConfig: {
        altFormat: "h:i K",
        altInput: true,
        dateFormat: "Y-m-d\\TH:i:S",
        defaultHour: 8,
        defaultMinute: 0,
        noCalendar: true,
        enableTime: true,
        time_24hr: true,
      },
      bulkUpdating: false,
      selectAll: false,
      activeReportTab: 0,
      dayWiseReport: {
        fromDate: null,
        toDate: null,
      },
      reportExporting: false,
      // Sorting state
      sortBy: "name",
      sortOrder: "asc",
      // Update All functionality
      updateAllObj: {
        month: null,
        year: new Date().getFullYear(),
      },
      updatingAll: false,
      availability: "All",
      availabilityOptions: [
        "All",
        "Part Time",
        "Full Time",
        "Probation",
        "Permanent",
        "Contractual",
        "Visiting",
        "Intern",
      ],
    };
  },
  validations: {
    depObj: {
      name: {
        required,
        minLength: minLength(4),
      },
    },
    age: {
      between: between(20, 30),
    },
  },
  methods: {
    ...mapActions({ getDepartment: "getDepartment" }),
    ...mapActions({ get: "get", post: "post", put: "put", delete: "delete" }),

    openSingle() {
      this.attReport = {
        months: [this.attMonth],
        year: this.attYear,
      };
      this.$bvModal.show("modal-single-report");
    },
    selectMonth(mon) {
      if (this.attReport.months.includes(mon)) {
        this.attReport.months = this.attReport.months.filter((m) => m != mon);
      } else {
        this.attReport.months.push(mon);
      }
    },
    showSingleReport(isExport) {
      const controller = isExport ? "Export" : "";
      this.reportExporting = isExport;

      var url =
        `https://${this.reportDomain}.myskool.app/Attendance/ShowStaffSingle${controller}?dtFrom=&dtTo=&dbb=` +
        this.$store.state.userData.db +
        "&cID=" +
        this.$store.state.userData.cId +
        "&depID=0&months=" +
        this.attReport.months.join(",") +
        "&year=" +
        this.attReport.year +
        "&tID=" +
        this.detailObj.id;

      if (isExport) {
        axios
          .get(url)
          .then((response) => {
            if (response.data.status == "success") {
              window.open(response.data.data, "_blank");
            } else {
              this.$bvToast.toast("Something went wrong", {
                title: this.$t("Error!"),
                variant: "danger",
                toaster: "b-toaster-top-center",
              });
            }
          })
          .catch((error) => {
            console.error("There was an error!", error);
          })
          .finally(() => {
            this.reportExporting = false;
          });
      } else {
        window.open(url, "_blank");
      }
    },

    openHoliday() {
      this.holiObj = {
        dtFrom: "",
        dtTo: "",
        campusIDs: [0],
        departmentIDs: [0],
        reason: "",
      };
      this.holiDate = "";
      this.visibility4 = true;

      if (this.shouldShowHolidayCampusDropdown) {
        this.loadHolidayCampuses();
      }
      // Default (All Campuses): load departments for current user campus
      this.loadHolidayDepartments(this.$store.state.userData.cId);

      this.$nextTick(() => {
        if (this.$refs["hol_campus"]) {
          this.$refs["hol_campus"].state = undefined;
        }
        if (this.$refs["hol_dep"]) {
          this.$refs["hol_dep"].state = undefined;
        }
        if (this.$refs["hol_dateF"]) {
          this.$refs["hol_dateF"].state = undefined;
        }
        if (this.$refs["hol_dateT"]) {
          this.$refs["hol_dateT"].state = undefined;
        }
        if (this.$refs["hol_reason"]) {
          this.$refs["hol_reason"].state = undefined;
        }
      });
    },
    openSundayModal() {
      this.sundayObj = {
        date: this.myObj.date || new Date().toJSON().split("T")[0],
      };
      this.visibilitySunday = true;
      if (this.$refs["sunday_date"]) {
        this.$refs["sunday_date"].state = undefined;
      }
    },
    setHoliCampus() {
      if (!Array.isArray(this.holiObj.campusIDs)) {
        this.holiObj.campusIDs = [0];
      } else if (this.holiObj.campusIDs.at(-1) == 0) {
        this.holiObj.campusIDs = [0];
      } else {
        this.holiObj.campusIDs = this.holiObj.campusIDs.filter((el) => el != 0);
      }

      // All Campuses → current user campus; otherwise first selected campus
      const ids = this.holiObj.campusIDs || [];
      const campusId =
        !ids.length || ids[0] == 0 ? this.$store.state.userData.cId : ids[0];

      this.holiObj.departmentIDs = [0];
      this.loadHolidayDepartments(campusId);
    },
    setHoliDept() {
      if (this.holiObj.departmentIDs.at(-1) == 0) {
        this.holiObj.departmentIDs = [0];
      } else {
        this.holiObj.departmentIDs = this.holiObj.departmentIDs.filter(
          (el) => el != 0
        );
      }
    },
    async loadHolidayCampuses() {
      try {
        const obj = {
          url:
            this.$store.state.domain +
            "campuses?db=" +
            this.$store.state.userData.db +
            "&cId=" +
            this.$store.state.userData.cId,
          token: this.$store.state.userData.token,
        };
        const campuses = await this.get(obj);
        this.holidayCampuses = Array.isArray(campuses) ? campuses : [];
      } catch (error) {
        console.error("Error loading campuses:", error);
        this.holidayCampuses = [];
      }
    },
    async loadHolidayDepartments(campusId) {
      const cId = campusId || this.$store.state.userData.cId;
      try {
        const res = await this.get({
          url:
            this.$store.state.domain +
            "staffdepartments?db=" +
            this.$store.state.userData.db +
            "&cId=" +
            cId,
          token: this.$store.state.userData.token,
        });
        this.holidayDepartments = [
          { name: "All Departments", id: 0 },
          ...(Array.isArray(res) ? res : []),
        ];
      } catch (error) {
        console.error("Error loading holiday departments:", error);
        this.holidayDepartments = [{ name: "All Departments", id: 0 }];
      }
    },
    buildHolidayCampusIDs() {
      if (!this.shouldShowHolidayCampusDropdown) {
        return null;
      }
      const ids = Array.isArray(this.holiObj.campusIDs)
        ? this.holiObj.campusIDs
        : [];
      if (!ids.length || ids[0] == 0) {
        return "0";
      }
      return ids.join(",");
    },
    buildHolidayDepartmentPayload() {
      const selectedIds = Array.isArray(this.holiObj.departmentIDs)
        ? this.holiObj.departmentIDs
        : [];
      const isAllDepartments = !selectedIds.length || selectedIds[0] == 0;

      if (isAllDepartments) {
        return {
          departmentIDs: [],
          departmentNames: [],
        };
      }

      const departmentNames = (this.holidayDepartments || [])
        .filter((dep) => selectedIds.includes(dep.id) && dep.id != 0)
        .map((dep) => dep.name)
        .filter(Boolean);

      return {
        departmentIDs: selectedIds,
        departmentNames,
      };
    },
    async markHoliday() {
      const campusIDs = this.buildHolidayCampusIDs();
      const requiresCampus =
        this.shouldShowHolidayCampusDropdown &&
        (!Array.isArray(this.holiObj.campusIDs) ||
          this.holiObj.campusIDs.length === 0);

      if (
        !this.holiObj.dtFrom ||
        !this.holiObj.dtTo ||
        !this.holiObj.reason ||
        this.holiObj.departmentIDs.length == 0 ||
        requiresCampus
      ) {
        if (this.$refs["hol_reason"] && !this.holiObj.reason) {
          this.$refs["hol_reason"].state = false;
        }
        return this.$bvToast.toast(
          this.$t("Please select all the required fields"),
          {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          }
        );
      } else if (this.holiObj.dtFrom > this.holiObj.dtTo) {
        return this.$bvToast.toast("Please select the date correctly!", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else {
        this.marking = true;
        const departmentPayload = this.buildHolidayDepartmentPayload();
        const queryCampusId =
          campusIDs != null ? 0 : this.$store.state.userData.cId;
        const body = {
          ...departmentPayload,
          dtFrom: this.holiObj.dtFrom,
          dtTo: this.holiObj.dtTo,
          reason: this.holiObj.reason,
          userID: this.$store.state.userData.userID,
        };
        if (campusIDs != null) {
          body.campusIDs = campusIDs;
        }

        const result = await this.post({
          url:
            this.$store.state.domain +
            "StaffAttendance/MarkHolidays?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            queryCampusId,
          body,
          context: this,
          token: this.$store.state.userData.token,
          message: "Attendance marked as holiday",
          returnData: true,
        });
        this.marking = false;
        if (result) {
          this.visibility4 = false;
          this.holidaySummary = result;
          this.holidaySummaryVisible = true;
        }
      }
    },

    getHolidayHistoryCampusId() {
      if (this.shouldShowHolidayCampusDropdown) return 0;
      return this.$store.state.userData.cId;
    },

    openHolidayHistory() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const lastDay = new Date(year, now.getMonth() + 1, 0).getDate();
      this.holidayHistoryFilters = {
        dtFrom: this.holiObj.dtFrom || `${year}-${month}-01`,
        dtTo:
          this.holiObj.dtTo ||
          `${year}-${month}-${String(lastDay).padStart(2, "0")}`,
        status: "H",
      };
      this.holidayHistoryVisible = true;
      this.loadHolidayHistory(1);
    },

    resetHolidayHistoryFilters() {
      this.holidayHistoryFilters = {
        dtFrom: "",
        dtTo: "",
        status: "",
      };
      this.loadHolidayHistory(1);
    },

    holidayHistoryStatusLabel(code) {
      const key = String(code || "").trim();
      if (!key) return "—";
      const map = {
        H: this.$t("Holiday"),
        EXL: this.$t("Exam Leave"),
        STL: this.$t("Study Leave"),
        Off: this.$t("Off"),
      };
      return map[key] || key;
    },

    holidayHistoryStatusVariant(code) {
      const key = String(code || "")
        .trim()
        .toUpperCase();
      if (key === "H") return "info";
      if (key === "EXL") return "dark";
      if (key === "STL") return "primary";
      if (key === "OFF") return "secondary";
      return "light";
    },

    resolveHolidayHistoryRowStatus(row) {
      if (!row) return "";
      return row.leaveStatus || row.status || row.eventType || "";
    },

    holidayHistoryRowId(row) {
      if (!row) return null;
      if (row.calendarId != null && row.calendarId !== "") {
        return row.calendarId;
      }
      if (row.calendarID != null && row.calendarID !== "") {
        return row.calendarID;
      }
      return row.id != null ? row.id : null;
    },

    getHolidayHistoryDeleteCampusId(row) {
      const rowCampus = row && row.campusID;
      if (rowCampus != null && Number(rowCampus) > 0) {
        return Number(rowCampus);
      }
      const histCampus = this.getHolidayHistoryCampusId();
      if (histCampus != null && Number(histCampus) > 0) {
        return Number(histCampus);
      }
      return this.$store.state.userData.cId;
    },

    formatHolidayHistoryCampus(row) {
      if (!row) return "—";
      if (row.branch) return row.branch;
      if (row.campusName) return row.campusName;
      if (Number(row.campusID) === 0) {
        return this.$t("All Campuses");
      }
      return "—";
    },

    extractHolidayHistoryStatusOptions(res) {
      if (res == null || typeof res !== "object") return [];
      const payload =
        res.data && typeof res.data === "object" && !Array.isArray(res.data)
          ? res.data
          : res;
      const raw = payload.statusOptions || res.statusOptions;
      if (!Array.isArray(raw) || !raw.length) return [];
      return raw
        .map((item) => {
          if (item == null) return null;
          if (typeof item === "string" || typeof item === "number") {
            const value = String(item).trim();
            if (!value) return null;
            return {
              label: this.holidayHistoryStatusLabel(value) + " (" + value + ")",
              value,
            };
          }
          if (typeof item === "object") {
            const value = String(
              item.value != null
                ? item.value
                : item.code != null
                ? item.code
                : item.status != null
                ? item.status
                : item.id != null
                ? item.id
                : ""
            ).trim();
            if (!value || value === "[object Object]") return null;
            const labelRaw = item.label || item.text || item.name || item.title;
            const label =
              labelRaw && typeof labelRaw !== "object"
                ? String(labelRaw)
                : this.holidayHistoryStatusLabel(value) + " (" + value + ")";
            return { label, value };
          }
          return null;
        })
        .filter(Boolean);
    },

    normalizeHolidayHistoryResponse(res) {
      if (res == null) return { items: [], total: 0, page: 1 };
      if (Array.isArray(res)) {
        return { items: res, total: res.length, page: 1 };
      }
      if (typeof res !== "object") return { items: [], total: 0, page: 1 };

      const payload = res.data && !Array.isArray(res.data) ? res.data : res;
      const items = Array.isArray(payload.data)
        ? payload.data
        : Array.isArray(payload.items)
        ? payload.items
        : Array.isArray(res.data)
        ? res.data
        : [];
      const total =
        Number(
          payload.filteredTotal ??
            payload.totalCount ??
            payload.totalRecords ??
            payload.total ??
            res.filteredTotal ??
            res.totalCount ??
            res.total ??
            items.length
        ) || 0;
      const page = Number(payload.page ?? res.page ?? 1) || 1;
      return { items, total, page };
    },

    async loadHolidayHistory(page = 1) {
      this.holidayHistoryPage = Math.max(1, Number(page) || 1);
      this.holidayHistoryLoading = true;
      try {
        const params = new URLSearchParams({
          db: this.$store.state.userData.db,
          cID: String(this.getHolidayHistoryCampusId()),
          page: String(this.holidayHistoryPage),
          pageSize: String(this.holidayHistoryPageSize),
        });
        if (this.holidayHistoryFilters.dtFrom) {
          params.set("dtFrom", this.holidayHistoryFilters.dtFrom);
        }
        if (this.holidayHistoryFilters.dtTo) {
          params.set("dtTo", this.holidayHistoryFilters.dtTo);
        }
        if (this.holidayHistoryFilters.status) {
          params.set("status", String(this.holidayHistoryFilters.status));
        }

        const raw = await this.get({
          url:
            this.$store.state.domain +
            "StaffAttendance/HolidayHistory?" +
            params.toString(),
          token: this.$store.state.userData.token,
          dashboard: true,
        });
        const normalized = this.normalizeHolidayHistoryResponse(raw);
        const statusOpts = this.extractHolidayHistoryStatusOptions(raw);
        if (statusOpts.length) {
          this.holidayHistoryStatusOptions = statusOpts;
        }
        this.holidayHistoryItems = normalized.items;
        this.holidayHistoryTotal = normalized.total;
        if (normalized.page > 0) this.holidayHistoryPage = normalized.page;
      } catch (e) {
        console.error("loadHolidayHistory:", e);
        this.holidayHistoryItems = [];
        this.holidayHistoryTotal = 0;
      } finally {
        this.holidayHistoryLoading = false;
      }
    },

    formatHolidayDate(value) {
      if (!value) return "—";
      const d = new Date(value);
      if (Number.isNaN(d.getTime())) return String(value).slice(0, 10);
      return d.toLocaleDateString("en-UK", {
        year: "numeric",
        day: "numeric",
        month: "short",
      });
    },

    formatHolidayDateTime(value) {
      if (!value) return "—";
      const d = new Date(value);
      if (Number.isNaN(d.getTime())) return String(value);
      return d.toLocaleString("en-UK", {
        year: "numeric",
        day: "numeric",
        month: "short",
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });
    },

    formatHolidayDepartments(value) {
      if (value == null || value === "") return this.$t("All Departments");
      if (Array.isArray(value)) {
        if (!value.length || (value.length === 1 && Number(value[0]) === 0)) {
          return this.$t("All Departments");
        }
        return value.join(", ");
      }
      if (typeof value === "string") {
        const trimmed = value.trim();
        if (!trimmed || trimmed === "0" || trimmed === "[]") {
          return this.$t("All Departments");
        }
        return trimmed;
      }
      return String(value);
    },

    async deleteHolidayHistory(row) {
      const calendarId = this.holidayHistoryRowId(row);
      if (!calendarId) return;
      const result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t(
          "This will remove the holiday calendar entry and related holiday attendance."
        ),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });
      if (!result.isConfirmed) return;

      this.holidayHistoryDeletingId = calendarId;
      try {
        const cID = this.getHolidayHistoryDeleteCampusId(row);
        const params = new URLSearchParams({
          db: this.$store.state.userData.db,
          cID: String(cID),
          id: String(calendarId),
          userID: String(this.$store.state.userData.userID || 0),
        });
        const status = await this.post({
          url:
            this.$store.state.domain +
            "StaffAttendance/DeleteHoliday?" +
            params.toString(),
          body: null,
          context: this,
          token: this.$store.state.userData.token,
          message: "Deleted successfully.",
        });
        if (status) {
          await this.loadHolidayHistory(this.holidayHistoryPage);
        }
      } catch (e) {
        console.error("deleteHolidayHistory:", e);
      } finally {
        this.holidayHistoryDeletingId = null;
      }
    },

    async markSundayOff() {
      if (!this.sundayObj.date) {
        if (this.$refs["sunday_date"]) this.$refs["sunday_date"].state = false;
        return this.$bvToast.toast("Please select the date.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }
      if (this.$refs["sunday_date"]) this.$refs["sunday_date"].state = true;

      this.markingSunday = true;
      const url =
        this.$store.state.domain +
        "StaffAttendance/MarkSundayOff?db=" +
        this.$store.state.userData.db +
        "&cID=" +
        this.$store.state.userData.cId +
        "&date=" +
        this.sundayObj.date;
      const status = await this.post({
        url,
        body: null,
        message: "Sunday marked off successfully!",
        context: this,
        token: this.$store.state.userData.token,
        showError: true,
      });
      this.markingSunday = false;
      if (status) {
        this.visibilitySunday = false;
        this.loadSummary();
      }
    },

    async DeleteAtt() {
      if (this.checkDep() == false) {
        this.$bvToast.toast("Please select the departments.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else if (this.checkDate() == false) {
        this.$bvToast.toast("Please select the date.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else {
        let result = await Swal.fire({
          title: this.$t("Are you sure?"),
          html: `<div class='text-left'><p class='mb-50'>Do you want to delete the attendance for</p><b>${new Date(
            this.myObj.date
          ).toLocaleDateString("en-UK", {
            year: "numeric",
            day: "numeric",
            month: "short",
          })}?</b></div>`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: this.$t("Yes, Delete it!"),
        });
        if (result.isConfirmed) {
          this.deleting = true;
          // StaffAttendance/DeleteAttendace

          let ids = this.myObj.depIDs[0] == 0 ? [] : this.myObj.depIDs;
          var status = await this.post({
            url:
              this.$store.state.domain +
              "StaffAttendance/DeleteAttByDep?db=" +
              this.$store.state.userData.db +
              "&cID=" +
              this.$store.state.userData.cId +
              "&dt=" +
              this.myObj.date,
            body: ids,
            message: "Attendance deleted successfully!",
            context: this,
            token: this.$store.state.userData.token,
          });
          this.deleting = false;
          if (status) {
            this.gridData = [];
            this.loadSummary();
          }
        }
      }
    },

    async loadSummary() {
      this.summLoading = true;
      let ids = this.myObj.depIDs[0] == 0 ? [] : this.myObj.depIDs;

      var res = await this.post({
        url:
          this.$store.state.domain +
          "Staff/LoadAttendanceSummary?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&dt=" +
          this.myObj.date +
          "&role=staff",
        body: ids,
        allResponse: true,
        context: this,
        token: this.$store.state.userData.token,
      });
      // console.log(res);
      if (res.summary) {
        this.summaryObj = res.summary;
      }
      this.summLoading = false;
      // var obj = {
      //   url:
      //     this.$store.state.domain +
      //     "Staff/LoadAttendanceByDate?db=" +
      //     this.$store.state.userData.db +
      //     "&cID=" +
      //     this.$store.state.userData.cId +
      //     "&dt=" +
      //     this.myObj.date +
      //     "&role=staff",
      //   token: this.$store.state.userData.token,
      //   dashboard: true,
      // };
      // let res = await this.get(obj);
      // this.summaryObj = res.summary;
    },

    getVariant(title) {
      const vt =
        title == "P"
          ? "success"
          : title == "A" || title == "AA"
          ? "danger"
          : ["L", "H", "SL", "HL", "WFH"].includes(title)
          ? "info"
          : title == "Off"
          ? "secondary"
          : title == "Extra Day"
          ? "primary"
          : "warning";

      return vt;
    },
    getPicturePreview(url) {
      if (!url) return "";
      if (String(url).startsWith("blob:")) return url;
      return getMediaPreviewUrl(url, "Image");
    },
    attendanceStatusDisplay(title) {
      const labels = {
        P: "Present",
        A: "Absent",
        AA: "Double absent",
        L: "Leave",
        SL: "Short leave",
        H: "Holiday",
        HL: "Half leave",
        Late: "Late",
        Off: "Off",
        "Extra Day": "Extra day",
        WFH: "WFH",
      };
      return labels[title] || title;
    },
    formatAttendanceClock(value) {
      if (!value) return "";
      try {
        return new Intl.DateTimeFormat("en-US", {
          hour: "numeric",
          minute: "numeric",
        }).format(new Date(value));
      } catch (_) {
        return "";
      }
    },
    pickSummaryNumber(summary, keys) {
      if (!summary || !keys) return null;
      for (let i = 0; i < keys.length; i++) {
        const raw = summary[keys[i]];
        if (raw !== null && raw !== undefined && raw !== "") {
          const n = Number(raw);
          if (Number.isFinite(n)) return n;
        }
      }
      return null;
    },
    attendanceSummaryHolidayCount() {
      const picked = this.pickSummaryNumber(this.countObj, [
        "holidays",
        "holiday",
        "holidayCount",
      ]);
      if (picked != null) return picked;
      const events = this.calendarOptions.events || [];
      return events.filter((e) =>
        ["H", "HL"].includes(String(e.title || e.status))
      ).length;
    },
    attendanceSummaryOffCount() {
      const picked = this.pickSummaryNumber(this.countObj, [
        "off",
        "offDays",
        "offs",
        "offday",
      ]);
      if (picked != null) return picked;
      const events = this.calendarOptions.events || [];
      return events.filter(
        (e) => String(e.title || e.status) === "Off"
      ).length;
    },
    stripAttendanceEventShell(info) {
      const el = info && info.el;
      if (!el || !el.classList) return;
      el.style.background = "transparent";
      el.style.backgroundColor = "transparent";
      el.style.border = "none";
      el.style.boxShadow = "none";
      el.style.outline = "none";
      const main = el.querySelector(".fc-event-main");
      if (main) {
        main.style.background = "transparent";
        main.style.backgroundColor = "transparent";
        main.style.border = "none";
        main.style.boxShadow = "none";
        main.style.padding = "0";
      }
      const frame = el.querySelector(".fc-event-main-frame");
      if (frame) {
        frame.style.background = "transparent";
        frame.style.backgroundColor = "transparent";
        frame.style.border = "none";
        frame.style.boxShadow = "none";
        frame.style.padding = "0";
      }
    },
    openDetail(item) {
      // console.log(item);
      this.detailObj = item;
      this.showDetails = true;

      this.attMonth = new Date().getMonth() + 1;
      this.attYear = new Date().getFullYear();
      this.loadAtt();
      // this.loadDetails("");
    },
    openEditAtt({ event: clickedEvent }) {
      if (!(this.rights.add || this.rights.edit)) return;
      this.openAttendanceEditorFromEvent(clickedEvent);
    },
    canEditStaffAttendance() {
      return !!(this.rights.add || this.rights.edit);
    },
    getAttendanceEventStatus(ev) {
      if (!ev) return "";
      if (ev.title != null && String(ev.title).trim() !== "") {
        return String(ev.title).trim();
      }
      if (ev.status != null && String(ev.status).trim() !== "") {
        return String(ev.status).trim();
      }
      return "";
    },
    isAttendanceDayAddable(dateStr, dateValue) {
      if (!this.canEditStaffAttendance()) return false;
      if (dateValue) {
        const d =
          dateValue instanceof Date ? dateValue : new Date(dateValue);
        if (
          d.getMonth() + 1 !== Number(this.attMonth) ||
          d.getFullYear() !== Number(this.attYear)
        ) {
          return false;
        }
      }
      const events = this.calendarOptions.events || [];
      const dayEvent = events.find((ev) =>
        this.attendanceEventMatchesDate(ev, dateStr)
      );
      if (dayEvent && this.getAttendanceEventStatus(dayEvent)) {
        return false;
      }
      return true;
    },
    onAttendanceDayClick(info) {
      if (!(this.rights.add || this.rights.edit)) {
        this.$bvToast.toast(
          this.$t("You do not have permission to edit attendance"),
          {
            title: this.$t("Error!"),
            variant: "warning",
            toaster: "b-toaster-top-center",
          }
        );
        return;
      }
      const dateStr = this.formatAttendanceDateKey(info.date);
      if (!this.isAttendanceDayAddable(dateStr, info.date)) {
        return;
      }
      const events = this.calendarOptions.events || [];
      const dayEvent = events.find((ev) =>
        this.attendanceEventMatchesDate(ev, dateStr)
      );
      if (dayEvent) {
        const status = this.getAttendanceEventStatus(dayEvent);
        if (status) return;
        this.currentObj = {
          ...dayEvent,
          id: parseInt(dayEvent.id, 10) || 0,
          tID: dayEvent.tID || this.getAttendanceStaffId(),
          date: dateStr,
          status: "",
          timeIn: dayEvent.timeIn || null,
          timeOut: dayEvent.timeOut || null,
          isOverRide:
            dayEvent.isOverRide != null ? dayEvent.isOverRide : true,
        };
        this.$bvModal.show("modal-att");
        return;
      }
      this.openAttendanceEditorForDate(dateStr);
    },
    formatAttendanceDateKey(dateValue) {
      const d = dateValue instanceof Date ? dateValue : new Date(dateValue);
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
        2,
        "0"
      )}-${String(d.getDate()).padStart(2, "0")}`;
    },
    attendanceEventMatchesDate(event, dateStr) {
      if (!event) return false;
      const raw = event.start || event.date;
      if (!raw) return false;
      if (typeof raw === "string" && raw.length >= 10) {
        return raw.slice(0, 10) === dateStr;
      }
      return this.formatAttendanceDateKey(raw) === dateStr;
    },
    getAttendanceStaffId() {
      return this.detailObj && this.detailObj.id;
    },
    getAttendanceUserID() {
      return (
        this.$store.state.userData.userID ||
        this.$store.state.userData.localID ||
        1
      );
    },
    openAttendanceEditorFromEvent(clickedEvent) {
      const { id, extendedProps, start, title } = clickedEvent;
      const dt = this.formatAttendanceDateKey(start);
      const status =
        (title != null && title !== undefined ? title : "") ||
        (extendedProps && extendedProps.status) ||
        "";
      this.currentObj = {
        ...(extendedProps || {}),
        id: parseInt(id, 10) || 0,
        tID:
          (extendedProps && extendedProps.tID) || this.getAttendanceStaffId(),
        date: dt,
        status,
        timeIn: (extendedProps && extendedProps.timeIn) || null,
        timeOut: (extendedProps && extendedProps.timeOut) || null,
        isOverRide:
          extendedProps && extendedProps.isOverRide != null
            ? extendedProps.isOverRide
            : true,
      };
      this.$bvModal.show("modal-att");
    },
    openAttendanceEditorForDate(dateStr) {
      this.currentObj = {
        id: 0,
        tID: this.getAttendanceStaffId(),
        date: dateStr,
        status: "",
        timeIn: null,
        timeOut: null,
        isOverRide: true,
      };
      this.$bvModal.show("modal-att");
    },
    computeMetaHours(timeIn, timeOut) {
      if (!timeIn || !timeOut) return 0;
      const ms = new Date(timeOut).getTime() - new Date(timeIn).getTime();
      if (!Number.isFinite(ms) || ms <= 0) return 0;
      return Math.round((ms / 3600000) * 100) / 100;
    },
    buildAttendanceSaveBody() {
      const meta =
        this.currentObj.meta_hours != null &&
        this.currentObj.meta_hours !== ""
          ? Number(this.currentObj.meta_hours)
          : this.computeMetaHours(
              this.currentObj.timeIn,
              this.currentObj.timeOut
            );
      return {
        id: Number(this.currentObj.id) || 0,
        tID: Number(this.currentObj.tID) || Number(this.getAttendanceStaffId()),
        date: this.currentObj.date,
        status: this.currentObj.status,
        timeIn: this.currentObj.timeIn || null,
        timeOut: this.currentObj.timeOut || null,
        meta_hours: meta,
        isOverRide:
          this.currentObj.isOverRide != null
            ? this.currentObj.isOverRide
            : true,
      };
    },
    async saveAtt() {
      if (!this.currentObj.status) {
        this.$bvToast.toast(this.$t("Please select a status"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
        return;
      }

      this.savingAtt = true;
      const userID = this.getAttendanceUserID();
      const body = this.buildAttendanceSaveBody();
      const recordId = Number(body.id) || 0;

      try {
        let status;
        if (recordId > 0) {
          status = await this.put({
            url:
              this.$store.state.domain +
              "staffAttendance/" +
              recordId +
              "?db=" +
              this.$store.state.userData.db +
              "&userID=" +
              userID,
            message: this.$t("Attendance updated successfully."),
            context: this,
            body: { ...body, userID },
            token: this.$store.state.userData.token,
          });
        } else {
          status = await this.post({
            url:
              this.$store.state.domain +
              "StaffAttendance/Save?db=" +
              this.$store.state.userData.db +
              "&cID=" +
              this.$store.state.userData.cId +
              "&userID=" +
              userID,
            message: this.$t("Attendance saved successfully."),
            context: this,
            body,
            token: this.$store.state.userData.token,
          });
        }
        if (status) {
          this.loadAtt();
          this.$bvModal.hide("modal-att");
        }
      } finally {
        this.savingAtt = false;
      }
    },
    change(val) {
      this.attMonth = val;
      this.loadAtt();
    },
    async loadAtt() {
      this.dataLoading = true;
      let dt = `${this.attYear}-${this.attMonth
        .toString()
        .padStart(2, "0")}-01`;

      var obj = {
        url:
          this.$store.state.domain +
          "Staff/LoadAttendanceCalendar?db=" +
          this.$store.state.userData.db +
          "&tID=" +
          this.detailObj.id +
          "&month=" +
          this.attMonth +
          "&year=" +
          this.attYear,
        token: this.$store.state.userData.token,
        dashboard: true,
      };
      let res = await this.get(obj);
      // console.log("res:", res);
      if (res.data.length > 0) {
        this.calendarOptions.events = res.data.map((el) => ({
          ...el,
          title: el.status != null ? el.status : "",
          start: el.date,
          backgroundColor: "transparent",
          borderColor: "transparent",
          textColor: "inherit",
        }));
      } else {
        this.calendarOptions.events = [];
      }
      this.countObj = res.summary || {};

      this.dataLoading = false;
      setTimeout(() => {
        var elem = this.$refs.refCalendar.getApi();
        elem.gotoDate(dt);
      }, 200);
    },

    async loadDetails(val) {
      this.dataLoading = true;
      var obj = {
        url:
          this.$store.state.domain +
          "Staff/LoadAttendance?db=" +
          this.$store.state.userData.db +
          "&tID=" +
          this.detailObj.id +
          "&duration=" +
          val,
        token: this.$store.state.userData.token,
        dashboard: true,
      };
      let res = await this.get(obj);
      this.detailItems = res.data;
      this.countObj = res.summary;
      // console.log("res:", res);
      this.dataLoading = false;
    },

    changeAtt(ind, val) {
      this.filters[ind].obj.status = val;
    },

    openReport() {
      const fd = new Date();
      const firstDate = `${fd.getFullYear()}-${(fd.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-01`;

      const ld = new Date(fd.getFullYear(), fd.getMonth() + 1, 0);
      const lastDate = `${ld.getFullYear()}-${(ld.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${ld.getDate().toString().padStart(2, "0")}`;

      // console.log(firstDate, lastDate);
      this.repObj = {
        dtFrom: firstDate,
        dtTo: lastDate,
        depIDs: 0,
        status: [],
      };
      this.dIDs = [0];
      this.repDate = `${firstDate} to ${lastDate}`;
      this.repSingleDate = fd.toJSON();
      this.visibility = true;

      var elem = this.$refs["rep_dep"];
      elem.state = undefined;
      var elem = this.$refs["rep_date"];
      elem.state = undefined;
      var elem = this.$refs["rep_single_date"];
      elem.state = undefined;
    },
    setRepDate(sd, dateStr) {
      // console.log(sd, dateStr);
      if (dateStr) {
        if (sd.length > 1) {
          let date = dateStr.split(" to ");
          if (date.length == 1) {
            this.repObj.dtFrom = date[0];
            this.repObj.dtTo = date[0];
          } else {
            this.repObj.dtFrom = date[0];
            this.repObj.dtTo = date[1];
          }
        } else {
          this.repObj.dtFrom = dateStr;
          this.repObj.dtTo = null;
        }
      } else {
        this.repObj.dtFrom = null;
        this.repObj.dtTo = null;
      }
      // console.log(this.repObj);
    },
    setStatus() {
      if (this.repObj.status[this.repObj.status.length - 1] == "") {
        this.repObj.status = [""];
      } else {
        this.repObj.status = this.repObj.status.filter((el) => el != "");
      }
      // console.log(this.repObj.status);
    },
    setDept() {
      if (this.dIDs.at(-1) == 0) {
        this.dIDs = [0];
      } else {
        this.dIDs = this.dIDs.filter((el) => el != 0);
      }
    },
    setGridDept() {
      if (this.myObj.depIDs.at(-1) == 0) {
        this.myObj.depIDs = [0];
      } else {
        this.myObj.depIDs = this.myObj.depIDs.filter((el) => el != 0);
      }
      this.checkDep();
      // console.log(this.myObj.depIDs);
    },
    CheckMultiDep() {
      var elem = this.$refs["dep_multi"];
      if (this.attObj && this.attObj.valueBool) {
        if (this.dIDs.length == 0) {
          return elem ? (elem.state = false) : false;
        } else {
          return elem ? (elem.state = true) : true;
        }
      } else {
        return elem ? (elem.state = true) : true;
      }
    },
    async getReport() {
      // console.log(this.repObj);
      let check = !this.repObj.dtFrom || !this.repObj.dtTo;
      if (this.singleVisible.includes(this.reportType)) {
        check = !this.repSingleDate;
      }
      if (check || !this.CheckMultiDep()) {
        return this.$bvToast.toast(
          this.$t("Please select all the required fields"),
          {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          }
        );
      } else {
        this.request = true;

        let ids = "";
        if (this.dIDs[0] > 0) {
          ids = this.dIDs.join(",");
        }

        const avail = this.availability == "All" ? "" : this.availability;

        let url =
          `https://${this.reportDomain}.myskool.app/Attendance/ShowStaff?type=` +
          (this.reportType == "general" ? "" : this.reportType) +
          "&dtFrom=" +
          this.repObj.dtFrom +
          "&dtTo=" +
          this.repObj.dtTo +
          "&dbb=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&depID=" +
          this.repObj.depIDs +
          "&dIDs=" +
          ids +
          "&availability=" +
          avail;

        if (this.singleVisible.includes(this.reportType)) {
          url =
            `https://${this.reportDomain}.myskool.app/Attendance/ShowStaff?type=${this.reportType}&dtFrom=` +
            this.repSingleDate +
            "&dtTo=" +
            this.repSingleDate +
            "&dbb=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&depID=" +
            this.repObj.depIDs +
            "&dIDs=" +
            ids +
            "&availability=" +
            avail;
        }

        window.open(url, "_blank");
        this.request = false;
      }
    },
    async exportReport() {
      // console.log(this.repObj);
      let check = !this.repObj.dtFrom || !this.repObj.dtTo;
      if (this.singleVisible.includes(this.reportType)) {
        check = !this.repSingleDate;
      }
      if (check || !this.CheckMultiDep()) {
        return this.$bvToast.toast(
          this.$t("Please select all the required fields"),
          {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          }
        );
      } else {
        this.exporting = true;

        let ids = "";
        if (this.dIDs[0] > 0) {
          ids = this.dIDs.join(",");
        }

        let url =
          `https://${this.reportDomain}.myskool.app/Attendance/ShowStaffExport?type=` +
          (this.reportType == "general" ? "" : this.reportType) +
          "&dtFrom=" +
          this.repObj.dtFrom +
          "&dtTo=" +
          this.repObj.dtTo +
          "&dbb=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&depID=" +
          this.repObj.depIDs +
          "&dIDs=" +
          ids;

        if (this.singleVisible.includes(this.reportType)) {
          url =
            `https://${this.reportDomain}.myskool.app/Attendance/ShowStaffExport?type=${this.reportType}&dtFrom=` +
            this.repSingleDate +
            "&dtTo=" +
            this.repSingleDate +
            "&dbb=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&depID=" +
            this.repObj.depIDs +
            "&dIDs=" +
            ids;
        }

        axios
          .get(url)
          .then((response) => {
            if (response.data.status == "success") {
              window.open(response.data.data, "_blank");
            } else {
              this.$bvToast.toast("Something went wrong", {
                title: this.$t("Error!"),
                variant: "danger",
                toaster: "b-toaster-top-center",
              });
            }
          })
          .catch((error) => {
            console.error("There was an error!", error);
          })
          .finally(() => {
            this.exporting = false;
          });
      }
    },

    openMessage() {
      this.msgObj = {
        dt: "",
        depIDs: [0],
        status: "P",
      };
      this.visibility2 = true;

      var elem = this.$refs["msg_dep"];
      elem.state = undefined;
      var elem = this.$refs["msg_date"];
      elem.state = undefined;
    },
    setMsgDept() {
      if (this.msgIDs[this.msgIDs.length - 1] == 0) {
        this.msgIDs = [0];
      } else {
        this.msgIDs = this.msgIDs.filter((el) => el != 0);
      }
      // console.log(this.msgIDs);
    },

    async saveMessage() {
      // console.log(this.msgObj);
      if (this.msgIDs.length == 0 || this.msgObj.dt == "") {
        return this.$bvToast.toast(
          this.$t("Please select all the required fields"),
          {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          }
        );
      } else {
        if (this.msgIDs[0] !== 0) {
          this.msgObj.depIDs = this.msgIDs;
        } else {
          this.msgObj.depIDs = [];
        }
        // console.log(this.msgObj);

        this.request = true;
        // var status = await this.post({
        //   url:
        //     this.$store.state.domain +
        //     " ?db=" +
        //     this.$store.state.userData.db +
        //     "&cID=" +
        //     this.$store.state.userData.cId,
        //   body: this.msgObj,
        //   message: "Message send successfully!",
        //   context: this,
        //   token: this.$store.state.userData.token,
        // });
        this.request = false;
        // if (status) {
        //   this.visibility2 = false;
        // }
      }
    },
    hideSideBar() {
      this.visibility = false;
    },
    checkDep() {
      var elem = this.$refs["dep"];
      if (this.myObj.depIDs.length == 0) {
        return elem ? (elem.state = false) : false;
      } else {
        return elem ? (elem.state = true) : true;
      }
    },
    checkDate() {
      var elem = this.$refs["date"];
      if (!this.myObj.date) {
        return elem ? (elem.state = false) : false;
      } else {
        return elem ? (elem.state = true) : true;
      }
    },
    async loadgrid() {
      // console.log(this.myObj);
      if (this.checkDep() == false) {
        this.$bvToast.toast("Please select the departments.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else if (this.checkDate() == false) {
        this.$bvToast.toast("Please select the date.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else {
        this.gridLoading = true;
        this.showGrid = true;

        this.request = true;
        // StaffAttendance/LoadAttendanceGrid
        let ids = this.myObj.depIDs[0] == 0 ? [] : this.myObj.depIDs;
        var status = await this.post({
          url:
            this.$store.state.domain +
            "StaffAttendance/LoadAttendanceByDep?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&dt=" +
            this.myObj.date +
            "&appointedFrom=" +
            (this.filter.appointedFrom || "") +
            "&appointedTo=" +
            (this.filter.appointedTo || "") +
            "&designation=" +
            encodeURIComponent(this.filter.designation || "") +
            "&sortBy=" +
            this.sortBy +
            "&sortOrder=" +
            this.sortOrder,
          body: ids,
          attendance: true,
          context: this,
          token: this.$store.state.userData.token,
        });
        this.request = false;
        if (status) {
          this.loadSummary();
          this.gridData = status;
          this.gridData = this.gridData.map((el) => ({
            ...el,
            inputTimein: el.obj.timeIn,
            inputTimeout: el.obj.timeOut,
          }));
          // console.log(this.gridData[0]);
        }
        this.gridLoading = false;
      }
    },
    async LoadSettings() {
      this.settLoading = true;
      let res = await this.post({
        url:
          this.$store.state.domain +
          "Settings/getSettings?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        body: ["notify-teacher", "notify-manager", "double-absent", "faceID"],
        context: this,
        token: this.$store.state.userData.token,
        subjects: true,
      });

      // console.log(res);
      this.notiTeacher = res.find((el) => el.key == "notify-teacher");
      if (!this.notiTeacher) {
        this.notiTeacher = {
          id: 0,
          campusID: this.$store.state.userData.cId,
          key: "notify-teacher",
          value: "notify-teacher",
          valueBool: false,
          valueNumber: null,
        };
      }
      this.notiManager = res.find((el) => el.key == "notify-manager");
      if (!this.notiManager) {
        this.notiManager = {
          id: 0,
          campusID: this.$store.state.userData.cId,
          key: "notify-manager",
          value: "",
          valueBool: false,
          valueNumber: null,
        };
      }
      this.doubleObj = res.find((el) => el.key == "double-absent");
      if (!this.doubleObj) {
        this.doubleObj = {
          id: 0,
          campusID: this.$store.state.userData.cId,
          key: "double-absent",
          value: "",
          valueBool: false,
          valueNumber: null,
        };
      }
      const faceIdSetting = res.find(
        (el) => el.key == "faceID" && el.value == "true"
      );
      this.showFaceId = faceIdSetting;
      // console.log(this.notiTeacher,this.notiManager, this.doubleObj);
      this.settLoading = false;
    },
    async LoadSettingsAll() {
      let res = await this.post({
        url:
          this.$store.state.domain +
          "Settings/getSettingsAll?db=" +
          this.$store.state.userData.db,
        body: ["attendance_reports"],
        context: this,
        token: this.$store.state.userData.token,
        subjects: true,
      });
      this.attObj = res.find((el) => el.key == "attendance_reports");
    },
    CheckContact(s, e) {
      if (this.notiManager.value != "") {
        if (e.valid) {
          this.phoneerror = false;
          this.notiManager.value = e.number;
          // console.log(this.notiManager.value);
        } else {
          this.phoneerror = true;
        }
      } else {
        this.phoneerror = false;
      }
    },
    async saveSettings() {
      if (this.notiManager.valueBool && this.notiManager.value.trim() == "") {
        this.phoneerror = true;
      } else if (!this.notiManager.valueBool) this.phoneerror = false;
      if (this.phoneerror) {
        this.$bvToast.toast("Invalid contact entered", {
          title: this.$t("Error!"),
          variant: "danger",
          solid: true,
        });
      } else {
        // console.log(this.notiTeacher, this.notiManager);
        this.savingSettings = true;
        var status = await this.post({
          url:
            this.$store.state.domain +
            "AttendanceSettings/Save?db=" +
            this.$store.state.userData.db,
          body: this.attSettings,
          importing: true,
          context: this,
          token: this.$store.state.userData.token,
        });

        status = await this.post({
          url:
            this.$store.state.domain +
            "Settings/SaveNew?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId,
          body: [this.notiTeacher, this.notiManager, this.doubleObj],
          importing: true,
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t("Notification"),
              icon: "CheckIcon",
              text: "Setting saved successfully!",
              variant: "success",
            },
          });
          this.visibility3 = false;
          this.loadAttSettings();
          this.LoadSettings();
        }
        this.savingSettings = false;
      }
    },
    async LoadInfo() {
      var obj = {
        url:
          this.$store.state.domain +
          "staffdepartments?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      let res = await this.get(obj);
      if (res.length > 0) {
        this.departments = [...this.departments, ...res];
      }
      // console.log("dept", this.departments);
    },
    async loadAttSettings() {
      var obj2 = {
        url:
          this.$store.state.domain +
          "AttendanceSettings/LoadBiometricSetting?campusID=" +
          this.$store.state.userData.cId +
          "&db=" +
          this.$store.state.userData.db,
        token: this.$store.state.userData.token,
      };
      let sett = await this.get(obj2);
      // console.log(sett);
      if (sett) {
        this.attSettings = sett;
        this.mode = sett.attendanceMode;
        // console.log(this.attSettings);
      }
    },

    async updateLate() {
      if (this.myObj.date) {
        // this.loadSummary();
        this.gridLoading = true;

        const date = new Date(this.myObj.date);
        const fd = this.myObj.date.split("-");
        const firstDate = `${fd[0]}-${fd[1]}-01`;

        const ld = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        const lastDate = `${ld.getFullYear()}-${(ld.getMonth() + 1)
          .toString()
          .padStart(2, "0")}-${ld.getDate().toString().padStart(2, "0")}`;

        // console.log(firstDate);
        // console.log(lastDate);

        var status = await this.get({
          url:
            this.$store.state.domain +
            "StaffAttendance/UpdateLateComing?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&dtFrom=" +
            firstDate +
            "&dtTo=" +
            lastDate,
          context: this,
          token: this.$store.state.userData.token,
        });
        this.gridLoading = false;
        // console.log(status);
        if (status == "Updated") {
          this.loadgrid();
        }
      }
    },
    async save() {
      if (this.gridData.length != 0) {
        this.saving = true;
        this.gridData.forEach((el) => {
          el.obj.timeIn = el.inputTimein == "" ? null : el.inputTimein;
          el.obj.timeOut = el.inputTimeout == "" ? null : el.inputTimeout;
        });
        var status = await this.post({
          url:
            this.$store.state.domain +
            "StaffAttendance/SaveWeb?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId,
          body: this.gridData,
          message: "Attendance saved successfully!",
          context: this,
          token: this.$store.state.userData.token,
        });
        this.saving = false;
        if (status) {
          this.loadgrid();
          // this.loadSummary();
        }
      }
    },

    async Delete(id) {
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });
      if (result.isConfirmed) {
        // var status = await this.delete({
        //   url:
        //     this.$store.state.domain +
        //     "OpeningBalance/" +
        //     id +
        //     "?db=" +
        //     this.$store.state.userData.db,
        //   body: null,
        //   message: "Opening Balance removed successfully.",
        //   context: this,
        // });
        // if (status) this.LoadData();
        console.log("balance deleted");
      }
    },

    openFaceAttendance() {
      const formattedDomain = this.reportDomain.replace(/_/g, "-");
      const campusId = this.$store.state.userData.cId;
      const baseUrl = `https://${formattedDomain}-${campusId}.cloudious.net`;

      window.open(baseUrl, "_blank");
    },

    copyFaceAttendanceLink() {
      const formattedDomain = this.reportDomain.replace(/_/g, "-");
      const campusId = this.$store.state.userData.cId;
      const baseUrl = `https://${formattedDomain}-${campusId}.cloudious.net`;

      navigator.clipboard.writeText(baseUrl);
      this.$root.$bvToast.toast("Link copied to clipboard", {
        title: this.$t("Success"),
        variant: "success",
        solid: true,
      });
    },
    resetFilters() {
      this.filter = {
        appointedFrom: null,
        appointedTo: null,
        designation: "",
      };
    },
    applyFilters() {
      // Hide the filter modal and apply the filters
      this.$bvModal.hide("modal-filter");
      this.loadgrid();
    },
    onSelectionChange() {
      // Update select all checkbox based on selections
      this.selectAll =
        this.selectedStaff.length === this.gridData.length &&
        this.gridData.length > 0;
    },
    openBulkUpdate() {
      if (this.selectedStaff.length === 0) {
        this.$bvToast.toast("Please select at least one staff member.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
        return;
      }
      this.bulkUpdateObj = {
        date: new Date().toJSON().split("T")[0], // Auto-populate with current date
        dateRange: null,
        timeIn: null,
        timeOut: null,
      };
      this.$bvModal.show("modal-bulk-update");
    },
    async saveBulkUpdate() {
      if (
        !this.bulkUpdateObj.dateRange ||
        !this.bulkUpdateObj.timeIn ||
        !this.bulkUpdateObj.timeOut
      ) {
        this.$bvToast.toast("Please enter Date Range, Time In and Time Out.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
        return;
      }

      this.bulkUpdating = true;
      try {
        // Parse date range to get individual dates
        const dateRange = this.bulkUpdateObj.dateRange;
        let dates = [];

        if (dateRange.includes(" to ")) {
          // Handle date range format "YYYY-MM-DD to YYYY-MM-DD"
          const [startDate, endDate] = dateRange.split(" to ");
          const start = new Date(startDate);
          const end = new Date(endDate);

          // Generate array of dates between start and end
          for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
            dates.push(d.toISOString().split("T")[0] + "T00:00:00");
          }
        } else {
          // Single date
          dates.push(dateRange + "T00:00:00");
        }

        // Prepare the bulk update request
        const bulkUpdateRequest = {
          staffIDs: this.selectedStaff,
          date: this.bulkUpdateObj.date, // Current date
          dates: dates, // Array of dates from date range
          timeIn: this.bulkUpdateObj.timeIn,
          timeOut: this.bulkUpdateObj.timeOut,
        };

        const status = await this.post({
          url: `${this.$store.state.domain}StaffAttendance/BulkUpdateTimeInMultiple?db=${this.$store.state.userData.db}&cID=${this.$store.state.userData.cId}`,
          body: bulkUpdateRequest,
          message: `Successfully updated ${this.selectedStaff.length} staff records for ${dates.length} date(s).`,
          context: this,
          token: this.$store.state.userData.token,
        });

        if (status) {
          this.selectedStaff = [];
          this.$bvModal.hide("modal-bulk-update");
          this.loadgrid(); // Reload the grid to show updated data
        }
      } catch (error) {
        console.error("Error updating staff:", error);
        this.$bvToast.toast("Error updating staff records.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }
      this.bulkUpdating = false;
    },
    getStaffName(staffId) {
      const staff = this.gridData.find((item) => item.id === staffId);
      return staff ? staff.name : `Staff ${staffId}`;
    },
    toggleSelectAll() {
      if (this.selectAll) {
        this.selectedStaff = this.gridData.map((item) => item.id);
      } else {
        this.selectedStaff = [];
      }
    },
    showDayWiseReport(isExport) {
      if (!this.dayWiseReport.fromDate || !this.dayWiseReport.toDate) {
        this.$bvToast.toast("Please select both From Date and To Date.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
        return;
      }

      const controller = isExport ? "Export" : "";
      this.reportExporting = isExport;
      // Use the same URL structure as monthly report but with date range
      var url =
        `https://${this.reportDomain}.myskool.app/Attendance/ShowStaffSingle${controller}?dtFrom=` +
        this.dayWiseReport.fromDate +
        "&dtTo=" +
        this.dayWiseReport.toDate +
        "&dbb=" +
        this.$store.state.userData.db +
        "&cID=" +
        this.$store.state.userData.cId +
        "&depID=0&months=0&year=0&tID=" +
        this.detailObj.id;

      if (isExport) {
        axios
          .get(url)
          .then((response) => {
            if (response.data.status == "success") {
              window.open(response.data.data, "_blank");
            } else {
              this.$bvToast.toast("Something went wrong", {
                title: this.$t("Error!"),
                variant: "danger",
                toaster: "b-toaster-top-center",
              });
            }
          })
          .catch((error) => {
            console.error("There was an error!", error);
          })
          .finally(() => {
            this.reportExporting = false;
          });
      } else {
        window.open(url, "_blank");
      }
    },
    // Sorting methods
    handleSort(key) {
      if (this.sortBy === key) {
        // Toggle sort order if same column
        this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      } else {
        // New column, set to ascending
        this.sortBy = key;
        this.sortOrder = "asc";
      }

      // Reload data with new sorting
      this.loadgrid();
    },
    // Update All methods
    openUpdateAll() {
      this.updateAllObj = {
        month: null,
        year: new Date().getFullYear(),
      };
      this.$bvModal.show("modal-update-all");
    },
    async updateAllAttendance() {
      if (!this.updateAllObj.month || !this.updateAllObj.year) {
        this.$bvToast.toast("Please select both month and year.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
        return;
      }

      this.updatingAll = true;
      try {
        const status = await this.get({
          url: `${this.$store.state.domain}StaffAttendance/CheckAttendanceStatus?db=${this.$store.state.userData.db}&cID=${this.$store.state.userData.cId}&month=${this.updateAllObj.month}&year=${this.updateAllObj.year}`,
          context: this,
          token: this.$store.state.userData.token,
        });

        if (status) {
          this.$bvToast.toast("Attendance status updated successfully!", {
            title: "Success!",
            variant: "success",
            toaster: "b-toaster-top-center",
          });
          this.$bvModal.hide("modal-update-all");
        }
      } catch (error) {
        console.error("Error updating attendance:", error);
        this.$bvToast.toast("Error updating attendance status.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }
      this.updatingAll = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/apps/calendar.scss";
@import "./_attendance-ui.scss";
</style>
<style scoped>
.image {
  float: left;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #ebebeb;
  margin: 5px;
}
.card {
  transition: 0.4s;
}
.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}
.card .card {
  box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1) !important;
  margin-bottom: 0.5rem;
}
.input-group {
  width: 140px;
}

/* Status buttons styling */
.status-buttons-container {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;
}

.status-btn {
  margin: 0 !important;
  padding: 0.25rem 0.5rem !important;
  min-width: 32px;
  height: 28px;
  font-size: 0.75rem;
  font-weight: 500;
  border-radius: 14px !important;
  transition: all 0.2s ease;
}

.status-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.status-btn:active {
  transform: translateY(0);
}

/* ── Holiday History Modal ─────────────────────────── */
.holiday-history-modal {
  border-radius: 14px;
  overflow: hidden;
}
.hh-modal {
  background: #fff;
  font-family: inherit;
}
.hh-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 20px;
  border-bottom: 1px solid #efeff7;
  background: #fafaff;
}
.hh-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}
.hh-header-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ece8ff;
  color: #7367f0;
}
.hh-header-title {
  font-size: 1.05rem;
  font-weight: 700;
  color: #2f2b3d;
  line-height: 1.2;
}
.hh-header-sub {
  font-size: 0.78rem;
  color: #8c879c;
  margin-top: 2px;
}
.hh-close-btn {
  border: 0;
  background: #f1f0f7;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #6e6b7b;
  cursor: pointer;
}
.hh-close-btn:hover {
  background: #e8e6f3;
  color: #2f2b3d;
}
.hh-filters {
  display: grid;
  grid-template-columns: 1fr 1fr minmax(160px, 1fr) auto;
  gap: 12px;
  align-items: end;
  padding: 14px 20px;
  border-bottom: 1px solid #f0f0f7;
  background: #fff;
}
.hh-filter-field label {
  display: block;
  margin-bottom: 4px;
  font-size: 0.75rem;
  font-weight: 600;
  color: #6e6b7b;
}
.hh-date-input {
  min-height: 38px;
  border-radius: 8px;
}
.hh-filter-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 1px;
}
.hh-btn-search {
  min-height: 38px;
  border-radius: 8px !important;
  padding-inline: 14px !important;
  display: inline-flex;
  align-items: center;
}
.hh-btn-clear {
  min-height: 38px;
  border-radius: 8px !important;
}
.hh-table-wrap {
  padding: 0 8px 8px;
  max-height: 52vh;
  overflow: auto;
}
.holiday-history-table {
  margin-bottom: 0;
}
.holiday-history-table thead th.hh-th {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #fff;
  border-top: 0;
  border-bottom: 1px solid #efeff7;
  color: #8c879c;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap;
  padding: 12px 14px;
}
.holiday-history-table tbody td.hh-td {
  padding: 12px 14px;
  vertical-align: middle;
  border-top: 1px solid #f5f4fa;
  color: #4b465c;
  font-size: 0.875rem;
}
.holiday-history-table tbody tr:hover td {
  background: #fafaff;
}
.hh-th-actions,
.hh-td-actions {
  width: 56px;
  text-align: center !important;
}
.hh-campus {
  font-weight: 600;
  color: #2f2b3d;
}
.hh-date-chip {
  display: inline-flex;
  align-items: center;
  padding: 3px 8px;
  border-radius: 6px;
  background: #f3f2f7;
  color: #5e5873;
  font-size: 0.8rem;
  white-space: nowrap;
}
.hh-reason {
  display: inline-block;
  max-width: 180px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.hh-status-cell {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
}
.hh-status-badge {
  font-size: 0.72rem;
  font-weight: 600;
}
.hh-status-meta {
  font-size: 0.68rem;
  color: #8c879c;
  max-width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.hh-dept-pill {
  display: inline-flex;
  align-items: center;
  padding: 3px 9px;
  border-radius: 999px;
  background: #eefbf3;
  color: #28c76f;
  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
}
.hh-muted {
  color: #8c879c;
  white-space: nowrap;
}
.hh-actions {
  display: flex;
  justify-content: center;
}
.hh-del-btn {
  width: 34px;
  height: 34px;
  border: 0;
  border-radius: 50%;
  background: #fdeeee;
  color: #ea5455;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s ease, transform 0.15s ease;
}
.hh-del-btn:hover:not(:disabled) {
  background: #ea5455;
  color: #fff;
  transform: translateY(-1px);
}
.hh-del-btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}
.hh-busy,
.hh-empty {
  text-align: center;
  padding: 2rem 1rem;
  color: #8c879c;
}
.hh-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 20px 16px;
  border-top: 1px solid #efeff7;
  background: #fafaff;
}
.hh-footer-count {
  font-size: 0.8rem;
  color: #8c879c;
}
@media (max-width: 768px) {
  .hh-filters {
    grid-template-columns: 1fr;
  }
  .hh-filter-actions {
    justify-content: flex-start;
  }
}

/* ── Holiday Summary Modal ─────────────────────────── */
.hs-modal {
  border-radius: 12px;
  overflow: hidden;
  font-family: inherit;
  background: #fff;
}

/* Header */
.hs-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 18px 22px 14px;
  border-bottom: 1px solid #f0f0f7;
  background: #fafafe;
}

.hs-header-left {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.hs-header-icon {
  flex-shrink: 0;
  width: 38px;
  height: 38px;
  background: #e6f9ee;
  color: #28a745;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hs-header-icon--warn {
  background: #fff4e5;
  color: #ff9f43;
}

.hs-header-title {
  font-size: 0.93rem;
  font-weight: 700;
  color: #2d2d3a;
  line-height: 1.3;
  margin-bottom: 6px;
}

.hs-header-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.hs-meta-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.71rem;
  font-weight: 500;
  color: #6e6b7b;
  background: #f0eef8;
  border-radius: 20px;
  padding: 2px 9px;
}

.hs-meta-badge--reason {
  background: #fff3e0;
  color: #d87c2a;
}

.hs-close-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: #bbb;
  padding: 4px;
  border-radius: 6px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s, color 0.15s;
  flex-shrink: 0;
}

.hs-close-btn:hover {
  background: #eeeef5;
  color: #555;
}

/* Stats */
.hs-stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  border-bottom: 1px solid #f0f0f7;
}

.hs-stat {
  padding: 16px 8px;
  text-align: center;
  border-right: 1px solid #f0f0f7;
}

.hs-stat:last-child {
  border-right: none;
}

.hs-stat-num {
  font-size: 1.65rem;
  font-weight: 800;
  line-height: 1;
  margin-bottom: 4px;
}

.hs-stat-lbl {
  font-size: 0.68rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #b0aec0;
}

.hs-stat--green .hs-stat-num {
  color: #28c76f;
}
.hs-stat--blue .hs-stat-num {
  color: #00cfe8;
}
.hs-stat--orange .hs-stat-num {
  color: #ff9f43;
}
.hs-stat--purple .hs-stat-num {
  color: #7367f0;
}
.hs-stat--red .hs-stat-num {
  color: #ea5455;
}

/* Message */
.hs-message {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 12px 22px 0;
  padding: 10px 12px;
  border-radius: 8px;
  background: #f3f2fd;
  color: #5e5873;
  font-size: 0.8rem;
  line-height: 1.4;
}

.hs-message--warn {
  background: #fff8ef;
  color: #9a6700;
  border: 1px solid #ffe2b8;
}

/* Body */
.hs-body {
  padding: 14px 22px;
}

.hs-body--top {
  padding-top: 14px;
}

.hs-section-label {
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #c0bdd0;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.hs-section-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 9px;
  background: #ffecec;
  color: #ea5455;
  font-size: 0.65rem;
  font-weight: 700;
}

/* Campus table */
.hs-campus-table {
  border: 1px solid #f0f0f7;
  border-radius: 8px;
  overflow: hidden;
  max-height: 250px;
  overflow-y: auto;
}

.hs-campus-thead {
  display: grid;
  grid-template-columns: 2fr 55px 75px 75px 100px;
  padding: 7px 14px;
  background: #f7f6fb;
  border-bottom: 1px solid #f0f0f7;
  font-size: 0.66rem;
  font-weight: 700;
  color: #b0aec0;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.hs-campus-thead span:not(:first-child),
.hs-td {
  text-align: center;
}

.hs-campus-row {
  display: grid;
  grid-template-columns: 2fr 55px 75px 75px 100px;
  align-items: center;
  padding: 9px 14px;
  border-bottom: 1px solid #f7f6fb;
  transition: background 0.12s;
}

.hs-campus-row:last-child {
  border-bottom: none;
}

.hs-campus-row:hover {
  background: #fafafe;
}

.hs-campus-info {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.hs-campus-branch {
  font-size: 0.82rem;
  font-weight: 600;
  color: #2d2d3a;
}

.hs-campus-org {
  font-size: 0.69rem;
  color: #b0aec0;
}

.hs-td {
  font-size: 0.82rem;
  font-weight: 600;
  color: #6e6b7b;
}

.hs-td--green {
  color: #28c76f;
}
.hs-td--blue {
  color: #00cfe8;
}
.hs-td--purple {
  color: #7367f0;
}

/* Skipped departments table */
.hs-skip-table {
  border: 1px solid #ffe8e8;
  border-radius: 8px;
  overflow: hidden;
  max-height: 250px;
  overflow-y: auto;
}

.hs-skip-thead {
  display: grid;
  grid-template-columns: 1.4fr 1fr 1.6fr;
  padding: 7px 14px;
  background: #fff5f5;
  border-bottom: 1px solid #ffe8e8;
  font-size: 0.66rem;
  font-weight: 700;
  color: #c0a0a0;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.hs-skip-row {
  display: grid;
  grid-template-columns: 1.4fr 1fr 1.6fr;
  align-items: center;
  gap: 8px;
  padding: 9px 14px;
  border-bottom: 1px solid #fff5f5;
}

.hs-skip-row:last-child {
  border-bottom: none;
}

.hs-skip-row:hover {
  background: #fffafa;
}

.hs-skip-dept {
  font-size: 0.8rem;
  font-weight: 600;
  color: #5e5873;
}

.hs-skip-reason {
  font-size: 0.75rem;
  color: #ea5455;
  font-weight: 500;
}

/* Footer */
.hs-footer {
  display: flex;
  justify-content: flex-end;
  padding: 12px 22px 14px;
  border-top: 1px solid #f0f0f7;
  background: #fafafe;
}

.hs-done-btn {
  padding: 6px 22px !important;
  font-size: 0.82rem !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
}
</style>
